const mapping: { [key: string]: string } = {
  FBANT000000: 'WC',
  FBANT001000: 'WC',
  FBANT002000: 'WCU',
  FBANT003000: 'WCS',
  FBANT005000: 'WCS',
  FBANT006000: 'WCN',
  FBANT007000: 'WC',
  FBANT008000: 'WCC',
  FBANT009000: 'WC',
  FBANT010000: 'WCJ',
  FBANT011000: 'WCF',
  FBANT012000: 'WCS',
  FBANT015000: 'WCW',
  FBANT016000: 'WCK',
  FBANT017000: 'WCL',
  FBANT018000: 'WCN',
  FBANT021000: 'WCP',
  FBANT022000: 'WC',
  FBANT023000: 'WCS',
  FBANT024000: 'WCK',
  FBANT025000: 'WC',
  FBANT029000: 'WCS',
  FBANT031000: 'WC',
  FBANT032000: 'WCN',
  FBANT033000: 'WCS',
  FBANT034000: 'WCU',
  FBANT035000: 'WCN',
  FBANT036000: 'WC',
  FBANT037000: 'WC',
  FBANT038000: 'WC',
  FBANT040000: 'WCV',
  FBANT041000: 'WCR',
  FBANT042000: 'WCT',
  FBANT042010: 'WCT',
  FBANT043000: 'WCT',
  FBANT044000: 'WCG',
  FBANT045000: 'WCW',
  FBANT047000: 'WCV',
  FBANT050000: 'WCW',
  FBANT051000: 'WC',
  FBANT052000: 'WC',
  FBANT053000: 'WCN',
  FBANT054000: 'WC',
  FBANT055000: 'WC',
  FBARC000000: 'AM',
  FBARC001000: 'AM',
  FBARC002000: 'AMC',
  FBARC003000: 'AMK',
  FBARC004000: 'AMC',
  FBARC005000: 'AMX',
  FBARC005010: 'AMX',
  FBARC005020: 'AMX',
  FBARC005030: 'AMX',
  FBARC005040: 'AMX',
  FBARC005050: 'AMX',
  FBARC005060: 'AMX',
  FBARC005070: 'AMX',
  FBARC005080: 'AMX',
  FBARC006000: 'AMB',
  FBARC006010: 'AMB',
  FBARC006020: 'AMB',
  FBARC007000: 'AMR',
  FBARC007010: 'AMR',
  FBARC008000: 'AMV',
  FBARC009000: 'AMC',
  FBARC010000: 'AMVD',
  FBARC011000: 'AMG',
  FBARC012000: 'AM',
  FBARC013000: 'AM',
  FBARC014000: 'AM',
  FBARC014010: 'AM',
  FBARC015000: 'AMD',
  FBARC016000: 'AMN',
  FBARC017000: 'AMD',
  FBARC018000: 'AMCR',
  FBARC019000: 'AMD',
  FBARC020000: 'AM',
  FBARC021000: 'AMC',
  FBARC022000: 'AMC',
  FBARC023000: 'AM',
  FBARC024000: 'AM',
  FBARC024010: 'AMG',
  FBART000000: 'AFC',
  FBART000000N: 'A',
  FBART001000: 'AKLC',
  FBART007000: 'AGZ',
  FBART009000: 'AB',
  FBART010000: 'AFF',
  FBART015050: 'AGA',
  FBART015060: 'AGA',
  FBART015070: 'AGA',
  FBART015080: 'AGA',
  FBART015090: 'AGA',
  FBART015100: 'AGA',
  FBART015110: 'AGA',
  FBART015120: 'AGA',
  FBART018000: 'AFCL',
  FBART020000: 'WFA',
  FBART026000: 'AFK',
  FBART028000: 'AGZ',
  FBART029000: 'AFCC',
  FBART031000: 'WFA',
  FBART037000: 'AB',
  FBART041000: 'AGA',
  FBART042000: 'AGA',
  FBART043000: 'ABQ',
  FBART044000: 'AGA',
  FBART045000: 'AFP',
  FBART046000: 'AFKV',
  FBART047000: 'AGA',
  FBART048000: 'AFH',
  FBART049000: 'AGA',
  FBART050000: 'AG',
  FBART050010: 'AGH',
  FBART050020: 'AGN',
  FBART050030: 'AGN',
  FBART050040: 'AGHF',
  FBART050050: 'AGHX',
  FBART053000: 'AFKB',
  FBART054000: 'AB',
  FBART055000: 'AFJ',
  FBART056000: 'ABC',
  FBART057000: 'AFKV',
  FBART058000: 'AFJ',
  FBART059000: 'GLZ',
  FBART060000: 'AFKP',
  FBBIB001000: 'QRMF1',
  FBBIB001010: 'QRMF1',
  FBBIB001020: 'QRMF1',
  FBBIB001030: 'QRMF13',
  FBBIB001040: 'QRMF1',
  FBBIB001050: 'QRMF1',
  FBBIB001060: 'QRMF1',
  FBBIB001070: 'QRMF1',
  FBBIB002000: 'QRMF1',
  FBBIB002010: 'QRMF1',
  FBBIB002020: 'QRMF1',
  FBBIB002030: 'QRMF13',
  FBBIB002040: 'QRMF1',
  FBBIB002050: 'QRMF1',
  FBBIB002060: 'QRMF1',
  FBBIB002070: 'QRMF1',
  FBBIB003000: 'QRMF1',
  FBBIB003010: 'QRMF1',
  FBBIB003020: 'QRMF1',
  FBBIB003030: 'QRMF13',
  FBBIB003040: 'QRMF1',
  FBBIB003050: 'QRMF1',
  FBBIB003060: 'QRMF1',
  FBBIB003070: 'QRMF1',
  FBBIB004000: 'QRMF1',
  FBBIB004010: 'QRMF1',
  FBBIB004020: 'QRMF1',
  FBBIB004030: 'QRMF13',
  FBBIB004040: 'QRMF1',
  FBBIB004050: 'QRMF1',
  FBBIB004060: 'QRMF1',
  FBBIB005000: 'QRMF1',
  FBBIB005010: 'QRMF1',
  FBBIB005020: 'QRMF1',
  FBBIB005030: 'QRMF13',
  FBBIB005040: 'QRMF1',
  FBBIB005050: 'QRMF1',
  FBBIB005060: 'QRMF1',
  FBBIB005070: 'QRMF1',
  FBBIB006000: 'QRMF1',
  FBBIB006010: 'QRMF1',
  FBBIB006020: 'QRMF1',
  FBBIB006030: 'QRMF13',
  FBBIB006040: 'QRMF1',
  FBBIB006050: 'QRMF1',
  FBBIB006060: 'QRMF1',
  FBBIB006070: 'QRMF1',
  FBBIB007000: 'QRMF1',
  FBBIB007010: 'QRMF1',
  FBBIB007020: 'QRMF1',
  FBBIB007030: 'QRMF13',
  FBBIB007040: 'QRMF1',
  FBBIB007050: 'QRMF1',
  FBBIB007060: 'QRMF1',
  FBBIB007070: 'QRMF1',
  FBBIB008000: 'QRMF1',
  FBBIB008010: 'QRMF1',
  FBBIB008020: 'QRMF1',
  FBBIB008030: 'QRMF13',
  FBBIB008040: 'QRMF1',
  FBBIB008050: 'QRMF1',
  FBBIB008060: 'QRMF1',
  FBBIB008070: 'QRMF1',
  FBBIB009000: 'QRMF1',
  FBBIB009010: 'QRMF1',
  FBBIB009020: 'QRMF1',
  FBBIB009030: 'QRMF13',
  FBBIB009040: 'QRMF1',
  FBBIB009050: 'QRMF1',
  FBBIB009060: 'QRMF1',
  FBBIB009070: 'QRMF1',
  FBBIB010000: 'QRMF1',
  FBBIB010010: 'QRMF1',
  FBBIB010020: 'QRMF1',
  FBBIB010030: 'QRMF13',
  FBBIB010040: 'QRMF1',
  FBBIB010050: 'QRMF1',
  FBBIB010060: 'QRMF1',
  FBBIB010070: 'QRMF1',
  FBBIB011000: 'QRMF1',
  FBBIB011010: 'QRMF1',
  FBBIB011020: 'QRMF1',
  FBBIB011030: 'QRMF13',
  FBBIB011040: 'QRMF1',
  FBBIB011050: 'QRMF1',
  FBBIB011060: 'QRMF1',
  FBBIB011070: 'QRMF1',
  FBBIB012000: 'QRMF1',
  FBBIB012010: 'QRMF1',
  FBBIB012020: 'QRMF1',
  FBBIB012030: 'QRMF13',
  FBBIB012040: 'QRMF1',
  FBBIB012050: 'QRMF1',
  FBBIB012060: 'QRMF1',
  FBBIB012070: 'QRMF1',
  FBBIB013000: 'QRMF1',
  FBBIB013010: 'QRMF1',
  FBBIB013020: 'QRMF1',
  FBBIB013030: 'QRMF13',
  FBBIB013040: 'QRMF1',
  FBBIB013050: 'QRMF1',
  FBBIB013060: 'QRMF1',
  FBBIB013070: 'QRMF1',
  FBBIB014000: 'QRMF1',
  FBBIB014010: 'QRMF1',
  FBBIB014020: 'QRMF1',
  FBBIB014030: 'QRMF13',
  FBBIB014040: 'QRMF1',
  FBBIB014050: 'QRMF1',
  FBBIB014060: 'QRMF1',
  FBBIB014070: 'QRMF1',
  FBBIB015000: 'QRMF1',
  FBBIB016000: 'QRMF1',
  FBBIB016010: 'QRMF1',
  FBBIB016020: 'QRMF1',
  FBBIB016030: 'QRMF13',
  FBBIB016040: 'QRMF1',
  FBBIB016050: 'QRMF1',
  FBBIB016060: 'QRMF1',
  FBBIB016070: 'QRMF1',
  FBBIB017000: 'QRMF1',
  FBBIB017010: 'QRMF1',
  FBBIB017020: 'QRMF1',
  FBBIB017030: 'QRMF13',
  FBBIB017040: 'QRMF1',
  FBBIB017050: 'QRMF1',
  FBBIB017060: 'QRMF1',
  FBBIB017070: 'QRMF1',
  FBBIB018000: 'QRMF1',
  FBBIB018010: 'QRMF1',
  FBBIB018020: 'QRMF1',
  FBBIB018030: 'QRMF13',
  FBBIB018040: 'QRMF1',
  FBBIB018050: 'QRMF1',
  FBBIB018060: 'QRMF1',
  FBBIB018070: 'QRMF1',
  FBBIB019000: 'QRMF1',
  FBBIB019010: 'QRMF1',
  FBBIB019020: 'QRMF1',
  FBBIB019030: 'QRMF13',
  FBBIB019040: 'QRMF1',
  FBBIB019050: 'QRMF1',
  FBBIB019060: 'QRMF1',
  FBBIB019070: 'QRMF1',
  FBBIB020000: 'QRMF1',
  FBBIB020010: 'QRMF1',
  FBBIB020020: 'QRMF1',
  FBBIB020030: 'QRMF13',
  FBBIB020040: 'QRMF1',
  FBBIB020050: 'QRMF1',
  FBBIB020060: 'QRMF1',
  FBBIB020070: 'QRMF1',
  FBBIO000000: 'DNB',
  FBBIO001000: 'DNB',
  FBBIO004000: 'DNBF',
  FBBIO005000: 'DNBF',
  FBBIO006000: 'DNBH',
  FBBIO007000: 'DNBL',
  FBBIO008000: 'DNBH',
  FBBIO009000: 'DNBM',
  FBBIO010000: 'DNBH',
  FBBIO011000: 'DNBH',
  FBBIO013000: 'DNBF',
  FBBIO014000: 'DNBR',
  FBBIO015000: 'DNBT',
  FBBIO016000: 'DNBS',
  FBBIO017000: 'DNBT',
  FBBIO018000: 'DNBX',
  FBBIO019000: 'DNB',
  FBBIO020000: 'DNB',
  FBBIO021000: 'DNBM',
  FBBIO022000: 'DNB',
  FBBIO023000: 'DNB',
  FBBIO024000: 'DNB',
  FBBIO025000: 'DNB',
  FBBIO026000: 'DNC',
  FBBIO028000: 'DNB',
  FBBUS000000: 'KJ',
  FBBUS001000: 'KFC',
  FBBUS001010: 'KFCF',
  FBBUS001020: 'KFCP',
  FBBUS001030: 'KJK',
  FBBUS001040: 'KFCM',
  FBBUS002000: 'KJSA',
  FBBUS003000: 'KFCM',
  FBBUS004000: 'KFFK',
  FBBUS005000: 'KFCM',
  FBBUS006000: 'KJMV1',
  FBBUS007000: 'KJP',
  FBBUS007010: 'KJP',
  FBBUS008000: 'KJG',
  FBBUS009000: 'KJP',
  FBBUS010000: 'LNC',
  FBBUS011000: 'KJP',
  FBBUS012000: 'KJ',
  FBBUS013000: 'KCL',
  FBBUS014000: 'KFFM',
  FBBUS015000: 'KJVB',
  FBBUS016000: 'KCK',
  FBBUS017000: 'KFFH',
  FBBUS018000: 'KJSU',
  FBBUS019000: 'KJMD',
  FBBUS020000: 'KJMV6',
  FBBUS021000: 'KCH',
  FBBUS022000: 'KCV',
  FBBUS023000: 'KCZ',
  FBBUS024000: 'KJB',
  FBBUS025000: 'KJH',
  FBBUS026000: 'KCL',
  FBBUS027000: 'KFF',
  FBBUS028000: 'KCL',
  FBBUS029000: 'KCS',
  FBBUS030000: 'KJMV2',
  FBBUS031000: 'KCBM',
  FBBUS032000: 'KCS',
  FBBUS033000: 'KFFN',
  FBBUS033010: 'KFFN',
  FBBUS033020: 'KFFN',
  FBBUS033040: 'KFFN',
  FBBUS033050: 'KFFN',
  FBBUS033060: 'KFFN',
  FBBUS033070: 'KFFN',
  FBBUS033080: 'KFFN',
  FBBUS034000: 'KFF',
  FBBUS035000: 'KJK',
  FBBUS036000: 'KFFM',
  FBBUS037020: 'KJ',
  FBBUS038000: 'KCF',
  FBBUS039000: 'KCB',
  FBBUS040000: 'KJS',
  FBBUS041000: 'KJM',
  FBBUS042000: 'KJM',
  FBBUS043000: 'KJS',
  FBBUS043010: 'KJS',
  FBBUS043020: 'KJS',
  FBBUS043030: 'KJK',
  FBBUS043040: 'KJS',
  FBBUS043050: 'KJS',
  FBBUS043060: 'KJSM',
  FBBUS044000: 'KCC',
  FBBUS045000: 'KCBM',
  FBBUS046000: 'KJMB',
  FBBUS047000: 'KJN',
  FBBUS048000: 'KJV',
  FBBUS049000: 'KJT',
  FBBUS050000: 'VSB',
  FBBUS050010: 'VSB',
  FBBUS050020: 'VSB',
  FBBUS050030: 'VSB',
  FBBUS050040: 'VSB',
  FBBUS050050: 'VSB',
  FBBUS051000: 'KFFD',
  FBBUS052000: 'KJSP',
  FBBUS053000: 'KJMQ',
  FBBUS054000: 'KFFR',
  FBBUS055000: 'KJ',
  FBBUS056030: 'KJ',
  FBBUS057000: 'KNP',
  FBBUS058000: 'KJS',
  FBBUS059000: 'KJW',
  FBBUS060000: 'KJVS',
  FBBUS061000: 'KCH',
  FBBUS062000: 'KCS',
  FBBUS063000: 'KJC',
  FBBUS064000: 'KFFD',
  FBBUS064010: 'KFFD',
  FBBUS064020: 'KJK',
  FBBUS064030: 'KFFD',
  FBBUS065000: 'KJMQ',
  FBBUS066000: 'KJMV2',
  FBBUS067000: 'KCVS',
  FBBUS068000: 'KCM',
  FBBUS069000: 'KC',
  FBBUS069010: 'KC',
  FBBUS069020: 'KCL',
  FBBUS069030: 'KCA',
  FBBUS070000: 'KN',
  FBBUS070010: 'KNA',
  FBBUS070020: 'KND',
  FBBUS070030: 'KNTX',
  FBBUS070040: 'KNB',
  FBBUS070050: 'KND',
  FBBUS070060: 'KNT',
  FBBUS070070: 'KNS',
  FBBUS070080: 'KNS',
  FBBUS070090: 'KND',
  FBBUS070100: 'KNG',
  FBBUS071000: 'KJMB',
  FBBUS072000: 'KCM',
  FBBUS073000: 'KCC',
  FBBUS074000: 'KJVX',
  FBBUS075000: 'KJL',
  FBBUS076000: 'KJMV8',
  FBBUS077000: 'KJZ',
  FBBUS078000: 'KJMV9',
  FBBUS079000: 'KCP',
  FBBUS080000: 'KJVS',
  FBBUS081000: 'KNS',
  FBBUS082000: 'KJM',
  FBBUS083000: 'KJMK',
  FBBUS084000: 'KJWF',
  FBBUS085000: 'KJU',
  FBBUS086000: 'KCJ',
  FBBUS087000: 'KJMV5',
  FBBUS088000: 'KJMT',
  FBBUS089000: 'KJWS',
  FBBUS090000: 'KJE',
  FBBUS090010: 'KJSG',
  FBBUS090030: 'KJE',
  FBBUS091000: 'KJQ',
  FBBUS092000: 'KCM',
  FBBUS093000: 'KJMV4',
  FBBUS094000: 'KJJ',
  FBBUS095000: 'KJWF',
  FBBUS096000: 'KJWB',
  FBBUS097000: 'KJWX',
  FBBUS098000: 'KJMK',
  FBBUS099000: 'KCVG',
  FBBUS100000: 'GLZ',
  FBBUS101000: 'KJMP',
  FBBUS102000: 'KJVT',
  FBBUS103000: 'KJU',
  FBCGN000000: 'XAK',
  FBCGN001000: 'XAK',
  FBCGN004010: 'XQD',
  FBCGN004020: 'XQX',
  FBCGN004030: 'XQM',
  FBCGN004040: 'XQH',
  FBCGN004050: 'XAM',
  FBCGN004060: 'XQC',
  FBCGN004070: 'XQL',
  FBCGN004080: 'XQK',
  FBCGN004090: 'XQR',
  FBCGN004100: 'XAM',
  FBCGN004110: 'XAMX',
  FBCGN004120: 'XAM',
  FBCGN004130: 'XAM',
  FBCGN004140: 'XAM',
  FBCGN004150: 'XAM',
  FBCGN004160: 'XAM',
  FBCGN004170: 'XAM',
  FBCGN004180: 'XAM',
  FBCGN004190: 'XAM',
  FBCGN004200: 'XAM',
  FBCGN006000: 'XAK',
  FBCGN007000: 'XQA',
  FBCGN008000: 'XAK',
  FBCGN009000: 'XAK',
  FBCKB000000: 'WB',
  FBCKB003000: 'WBVD',
  FBCKB004000: 'WBVS',
  FBCKB005000: 'WBS',
  FBCKB006000: 'WBXD',
  FBCKB007000: 'WBXD2',
  FBCKB008000: 'WBXN',
  FBCKB012000: 'WBV',
  FBCKB014000: 'WBVS1',
  FBCKB015000: 'WBW',
  FBCKB018000: 'WBTX',
  FBCKB019000: 'WBXN',
  FBCKB020000: 'WBC',
  FBCKB021000: 'WBVS',
  FBCKB023000: 'WBA',
  FBCKB024000: 'WBV',
  FBCKB032000: 'WBTB',
  FBCKB035000: 'WBTM',
  FBCKB037000: 'WBA',
  FBCKB039000: 'WBH',
  FBCKB040000: 'WBTH',
  FBCKB041000: 'WB',
  FBCKB054000: 'WBTB',
  FBCKB057000: 'WBS',
  FBCKB059000: 'WBH',
  FBCKB061000: 'WBTP',
  FBCKB063000: 'WBVS',
  FBCKB064000: 'WBV',
  FBCKB067000: 'WBTC',
  FBCKB070000: 'WBF',
  FBCKB071000: 'WB',
  FBCKB073000: 'WBVG',
  FBCKB076000: 'WBTF',
  FBCKB079000: 'WBVD',
  FBCKB085000: 'WBTM',
  FBCKB088000: 'WBXD',
  FBCKB089000: 'WBS',
  FBCKB095000: 'WBVQ',
  FBCKB096000: 'WBTR',
  FBCKB098000: 'WBTJ',
  FBCKB100000: 'WBX',
  FBCKB101000: 'WBA',
  FBCKB105000: 'WBT',
  FBCKB107000: 'WBQ',
  FBCOM000000: 'U',
  FBCOM007000: 'UGC',
  FBCOM010000: 'UMC',
  FBCOM012000: 'UG',
  FBCOM012050: 'UG',
  FBCOM020000N: 'UG',
  FBCOM020090: 'UTW',
  FBCOM022000: 'UGD',
  FBCOM030000: 'UTE',
  FBCOM030000N: 'UF',
  FBCOM040000N: 'UK',
  FBCOM043000: 'UT',
  FBCOM046000: 'UL',
  FBCOM046020: 'ULH',
  FBCOM046040: 'ULD',
  FBCOM046070: 'ULJ',
  FBCOM046090: 'UTV',
  FBCOM051010: 'UM',
  FBCOM051040: 'UYFL',
  FBCOM051060: 'UMX',
  FBCOM051100: 'UMX',
  FBCOM051170: 'UMX',
  FBCOM051200: 'UMX',
  FBCOM051260: 'UMX',
  FBCOM051270: 'UMX',
  FBCOM051280: 'UMX',
  FBCOM051320: 'UMX',
  FBCOM051350: 'UMX',
  FBCOM051360: 'UMX',
  FBCOM051400: 'UMX',
  FBCOM051410: 'UMX',
  FBCOM053000: 'UR',
  FBCOM059000: 'UY',
  FBCOM060000: 'UMW',
  FBCOM060000N: 'UN',
  FBCOM060100: 'UD',
  FBCOM060140: 'UDBS',
  FBCOM064000: 'KJE',
  FBCOM067000: 'UK',
  FBCOM071000: 'UGV',
  FBCOM081000: 'UFP',
  FBCOM084000: 'UF',
  FBCOM084010N: 'UDB',
  FBCOM087010: 'UGM',
  FBCOM088000: 'UTE',
  FBCOM088010: 'UTE',
  FBCOM088020: 'UTE',
  FBCRA000000: 'WF',
  FBCRA003000: 'WFS',
  FBCRA004000: 'WFBS2',
  FBCRA005000: 'WJK',
  FBCRA008000: 'WFBC',
  FBCRA009000: 'WFB',
  FBCRA010000: 'WFW',
  FBCRA011000: 'WFQ',
  FBCRA012000: 'WFN',
  FBCRA014000: 'WFJ',
  FBCRA015000: 'WFBS1',
  FBCRA016000: 'WFBL',
  FBCRA017000: 'WFP',
  FBCRA020000: 'WFT',
  FBCRA021000: 'WFBC',
  FBCRA022000: 'WFB',
  FBCRA023000: 'WFTM',
  FBCRA024000: 'WFA',
  FBCRA026000: 'WFBQ',
  FBCRA028000: 'WFN',
  FBCRA030000: 'ATXM',
  FBCRA035000: 'WFBW',
  FBCRA036000: 'WFA',
  FBCRA040000: 'WFG',
  FBCRA043000: 'WF',
  FBCRA044000: 'WFBC',
  FBCRA045000: 'WDHM',
  FBCRA046000: 'WFT',
  FBCRA047000: 'WFV',
  FBCRA048000: 'WFJ',
  FBCRA049000: 'WFS',
  FBDES000000: 'AK',
  FBDES001000: 'AKH',
  FBDES002000: 'AK',
  FBDES003000: 'AFT',
  FBDES004000: 'AK',
  FBDES005000: 'AKT',
  FBDES006000: 'AKR',
  FBDES007000: 'AKC',
  FBDES007010: 'AKL',
  FBDES007020: 'AKL',
  FBDES007030: 'AKL',
  FBDES007040: 'AKLB',
  FBDES007050: 'AKD',
  FBDES008000: 'AK',
  FBDES009000: 'AK',
  FBDES010000: 'WJK',
  FBDES011000: 'AKP',
  FBDES012000: 'AK',
  FBDES013000: 'AKT',
  FBDRA000000: 'DD',
  FBEDU000000: 'JN',
  FBEDU002000: 'JNP',
  FBEDU010000N: 'JNV',
  FBEDU015000: 'JNM',
  FBEDU023000: 'JNL',
  FBEDU024000: 'JN',
  FBEDU026000: 'JNS',
  FBEDU026020: 'JNSG',
  FBEDU026030: 'JNS',
  FBEDU026040: 'JNSC',
  FBEDU030000N: 'JN',
  FBEDU040000N: 'JN',
  FBEDU042000: 'JN',
  FBFAM000000: 'VF',
  FBFAM001000: 'JBFK',
  FBFAM003000: 'VFV',
  FBFAM004000: 'JKSF',
  FBFAM006000: 'VFV',
  FBFAM008000: 'VFXB1',
  FBFAM012000: 'JBSP1',
  FBFAM013000: 'VFV',
  FBFAM015000: 'VFVS',
  FBFAM016000: 'VF',
  FBFAM019000: 'VFX',
  FBFAM020000: 'VFV',
  FBFAM020000N: 'VFJG',
  FBFAM023000: 'VFD',
  FBFAM025000: 'VFXB',
  FBFAM028000: 'VFJD',
  FBFAM029000: 'VFVG',
  FBFAM030000: 'VFVG',
  FBFAM032000: 'VFV',
  FBFAM033000: 'VFV',
  FBFAM034010: 'VFX',
  FBFAM041000: 'VFV',
  FBFAM042000: 'VFVS',
  FBFAM044000: 'VFXC',
  FBFIC000000: 'FB',
  FBFIC002000: 'FJ',
  FBFIC003000: 'DNT',
  FBFIC004000: 'FBC',
  FBFIC005000: 'FP',
  FBFIC006000: 'FHD',
  FBFIC009000: 'FM',
  FBFIC009010N: 'FM',
  FBFIC009020: 'FM',
  FBFIC009030: 'FMH',
  FBFIC009040: 'FM',
  FBFIC010000: 'FN',
  FBFIC011000: 'FB',
  FBFIC012000: 'FK',
  FBFIC014000: 'FV',
  FBFIC015000: 'FK',
  FBFIC016000: 'FU',
  FBFIC018000: 'FB',
  FBFIC019000: 'FB',
  FBFIC021000: 'FB',
  FBFIC022000: 'FF',
  FBFIC022010: 'FFL',
  FBFIC022020: 'FFP',
  FBFIC022030: 'FFC',
  FBFIC022040: 'FFS',
  FBFIC022050: 'FF',
  FBFIC022060: 'FFH',
  FBFIC024000: 'FKW',
  FBFIC027000: 'FR',
  FBFIC027010: 'FRX',
  FBFIC027020: 'FRD',
  FBFIC027030: 'FMR',
  FBFIC027040: 'FB',
  FBFIC027050: 'FRH',
  FBFIC027070: 'FRH',
  FBFIC027080: 'FR',
  FBFIC027090: 'FR',
  FBFIC027100: 'FR',
  FBFIC027110: 'FRM',
  FBFIC027120: 'FMR',
  FBFIC028000: 'FL',
  FBFIC028010: 'FL',
  FBFIC028020: 'FL',
  FBFIC028030: 'FLS',
  FBFIC028040: 'FL',
  FBFIC028050: 'FLR',
  FBFIC029000: 'FYB',
  FBFIC030000: 'FH',
  FBFIC031000: 'FH',
  FBFIC032000: 'FJM',
  FBFIC033000: 'FJW',
  FBFIC034000: 'FB',
  FBFIC041000: 'FC',
  FBFIC042000: 'FW',
  FBFIC042010: 'FW',
  FBFIC042020: 'FW',
  FBFIC042030: 'FV',
  FBFIC042040: 'FR',
  FBFIC042050: 'FW',
  FBFIC042060: 'FW',
  FBFIC042070: 'FW',
  FBFIC042080: 'FW',
  FBFIC044000: 'FQ',
  FBFIC047000: 'FJ',
  FBFOR000000: 'CJ',
  FBFOR001000: 'CJ',
  FBFOR002000: 'CJ',
  FBFOR003000: 'CJ',
  FBFOR004000: 'CJ',
  FBFOR005000: 'CBDX',
  FBFOR006000: 'CJ',
  FBFOR007000: 'CJ',
  FBFOR008000: 'CJ',
  FBFOR009000: 'CJ',
  FBFOR010000: 'CJ',
  FBFOR011000: 'CJ',
  FBFOR012000: 'CJ',
  FBFOR013000: 'CJ',
  FBFOR014000: 'CJ',
  FBFOR015000: 'CJ',
  FBFOR016000: 'CJ',
  FBFOR017000: 'CJ',
  FBFOR018000: 'WTK',
  FBFOR019000: 'CJ',
  FBFOR020000: 'CJ',
  FBFOR021000: 'CJ',
  FBFOR022000: 'CJ',
  FBFOR023000: 'CJ',
  FBFOR024000: 'CJ',
  FBFOR025000: 'CJ',
  FBFOR026000: 'CJ',
  FBFOR027000: 'CJ',
  FBFOR028000: 'CJ',
  FBFOR029000: 'CJ',
  FBFOR030000: 'CJ',
  FBFOR031000: 'CJ',
  FBFOR032000: 'CJ',
  FBFOR033000: 'CJ',
  FBFOR034000: 'CJ',
  FBFOR035000: 'CJ',
  FBFOR036000: 'CJ',
  FBFOR037000: 'CJ',
  FBFOR038000: 'CJ',
  FBFOR039000: 'CJ',
  FBFOR040000: 'CJ',
  FBFOR041000: 'CJ',
  FBFOR042000: 'CJ',
  FBFOR043000: 'CJ',
  FBFOR044000: 'CJ',
  FBFOR045000: 'CJ',
  FBGAM000000: 'WD',
  FBGAM001000: 'WDMG',
  FBGAM001010: 'WDMG',
  FBGAM001020: 'WDMG1',
  FBGAM002000: 'WDMC',
  FBGAM002010: 'WDMC1',
  FBGAM002030: 'WDMC',
  FBGAM002040: 'WDMC2',
  FBGAM003000: 'WDKC',
  FBGAM003040: 'WDKC',
  FBGAM004000: 'WDP',
  FBGAM004020: 'WDP',
  FBGAM004030: 'WDP',
  FBGAM004040: 'WDP',
  FBGAM004050: 'WDP',
  FBGAM005000: 'WDK',
  FBGAM006000: 'ATX',
  FBGAM007000: 'WDK',
  FBGAM008000: 'WDKX',
  FBGAM009000: 'WD',
  FBGAM010000: 'WDHW',
  FBGAM011000: 'WD',
  FBGAM012000: 'WDKX',
  FBGAM013000: 'UDX',
  FBGAM014000: 'WDK',
  FBGAM017000: 'WDKN',
  FBGAR000000: 'WM',
  FBGAR002000: 'WM',
  FBGAR004000: 'WMP',
  FBGAR004010: 'WMP',
  FBGAR004030: 'WMP',
  FBGAR004040: 'WMP',
  FBGAR004050: 'WMP',
  FBGAR004060: 'WMP',
  FBGAR004080: 'WMP',
  FBGAR005000: 'WMP',
  FBGAR006000: 'WMD',
  FBGAR007000: 'WMD',
  FBGAR010000: 'WMP',
  FBGAR016000: 'WMQF',
  FBGAR017000: 'WMP',
  FBGAR022000: 'WMQ',
  FBGAR024000: 'WMP',
  FBGAR025000: 'WMP',
  FBGAR028000: 'WMQ',
  FBHEA000000: 'VF',
  FBHEA003000: 'WJH',
  FBHEA006000: 'VFMD',
  FBHEA014000: 'VFMG',
  FBHEA016000: 'VXH',
  FBHEA039000: 'VFJB',
  FBHEA041000: 'VFXB',
  FBHEA042000: 'VFVC',
  FBHEA043000: 'VFJB',
  FBHEA044000: 'VFXB',
  FBHEA045000: 'VFVJ',
  FBHIS000000: 'NH',
  FBHIS001000: 'NHH',
  FBHIS001000N: 'NHB',
  FBHIS001010: 'NHH',
  FBHIS001020: 'NHH',
  FBHIS001030: 'NHH',
  FBHIS001040: 'NHH',
  FBHIS001050: 'NHH',
  FBHIS002000: 'NHC',
  FBHIS002010: 'NHC',
  FBHIS002020: 'NHDA',
  FBHIS002020N: 'NHB',
  FBHIS002030: 'NHC',
  FBHIS003000: 'NHF',
  FBHIS004000: 'NHM',
  FBHIS005000: 'NHD',
  FBHIS006000: 'NHK',
  FBHIS006010: 'NHK',
  FBHIS006020: 'NHK',
  FBHIS007000: 'NHK',
  FBHIS008000: 'NHF',
  FBHIS009000: 'NHG',
  FBHIS010000: 'NHD',
  FBHIS010010: 'NHD',
  FBHIS013000: 'NHD',
  FBHIS014000: 'NHD',
  FBHIS015000: 'NHD',
  FBHIS016000: 'NHAH',
  FBHIS017000: 'NHF',
  FBHIS018000: 'NHD',
  FBHIS019000: 'NHG',
  FBHIS020000: 'NHD',
  FBHIS021000: 'NHF',
  FBHIS023000: 'NHF',
  FBHIS025000: 'NHK',
  FBHIS026000: 'NHG',
  FBHIS027000: 'JW',
  FBHIS027020: 'NHWR9',
  FBHIS027040: 'NHWR9',
  FBHIS027070: 'NHWR9',
  FBHIS027090: 'NHWR5',
  FBHIS027100: 'NHWR7',
  FBHIS027120: 'JWXV',
  FBHIS027170: 'NHWR9',
  FBHIS027180: 'JWCS',
  FBHIS027190: 'NHWR9',
  FBHIS028000: 'NHK',
  FBHIS031000: 'NHTV',
  FBHIS032000: 'NHQ',
  FBHIS033000: 'NHK',
  FBHIS035000: 'NHB',
  FBHIS036000: 'NHK',
  FBHIS036010: 'NHK',
  FBHIS036020: 'NHK',
  FBHIS036030: 'NHK',
  FBHIS036050: 'NHK',
  FBHIS036080: 'NHK',
  FBHIS036090: 'NHK',
  FBHIS036100: 'NHK',
  FBHIS036110: 'NHK',
  FBHIS036120: 'NHK',
  FBHIS036130: 'NHK',
  FBHIS036140: 'NHK',
  FBHIS037010: 'NHDJ',
  FBHIS037020: 'NHDL',
  FBHIS037060: 'NHB',
  FBHIS037070: 'NHB',
  FBHIS037080: 'NHB',
  FBHIS040000: 'NHD',
  FBHIS041000: 'NHK',
  FBHIS041010: 'NHK',
  FBHIS042000: 'NHD',
  FBHIS043000: 'NHTZ1',
  FBHIS044000: 'NHD',
  FBHIS045000: 'NHD',
  FBHIS047000: 'NHH',
  FBHIS048000: 'NHF',
  FBHIS049000: 'NHB',
  FBHIS050000: 'NHF',
  FBHIS053000: 'NHM',
  FBHIS054000: 'NHTB',
  FBHIS055000: 'NHG',
  FBHOM000000: 'WK',
  FBHOM001000: 'WKDW',
  FBHOM003000: 'WJK',
  FBHOM004000: 'WK',
  FBHOM005000: 'WKD',
  FBHOM006000: 'WKD',
  FBHOM009000: 'WKD',
  FBHOM012000: 'WKD',
  FBHOM013000: 'WKU',
  FBHOM014000: 'WKD',
  FBHOM017000: 'WKR',
  FBHOM019000: 'WKDM',
  FBHOM020000: 'WKDM',
  FBHOM021000: 'WK',
  FBHOM022000: 'WK',
  FBHUM000000: 'WH',
  FBHUM001000: 'WHX',
  FBHUM003000: 'WHX',
  FBHUM004000: 'WHJ',
  FBHUM005000: 'WH',
  FBHUM006000: 'WH',
  FBHUM007000: 'WHP',
  FBHUM008000: 'WH',
  FBHUM009000: 'WH',
  FBHUM010000: 'WH',
  FBHUM011000: 'WH',
  FBHUM012000: 'WH',
  FBHUM013000: 'WH',
  FBHUM014000: 'WH',
  FBHUM015000: 'WHX',
  FBJNF000000: 'YN',
  FBJNF001000: 'YBG',
  FBJNF002000: 'YNHA',
  FBJNF003000: 'YNN',
  FBJNF003010: 'YNNJ29',
  FBJNF003020: 'YNNJ23',
  FBJNF003030: 'YNNK',
  FBJNF003040: 'YNNJ22',
  FBJNF003050: 'YNNA',
  FBJNF003060: 'YNNJ21',
  FBJNF003070: 'YNNJ2',
  FBJNF003080: 'YNNF',
  FBJNF003090: 'YNNS',
  FBJNF003100: 'YNNJ3',
  FBJNF003110: 'YNNJ24',
  FBJNF003120: 'YNNL',
  FBJNF003130: 'YNNJ22',
  FBJNF003140: 'YNNJ',
  FBJNF003150: 'YNNS',
  FBJNF003160: 'YNNJ31',
  FBJNF003170: 'YNNH',
  FBJNF003180: 'YNNJ31',
  FBJNF003190: 'YNNM',
  FBJNF003200: 'YNN',
  FBJNF003210: 'YNNK',
  FBJNF003220: 'YNN',
  FBJNF003230: 'YNNJ2',
  FBJNF003240: 'YNNJ21',
  FBJNF003250: 'YNNL',
  FBJNF003260: 'YNNJ25',
  FBJNF003270: 'YNN',
  FBJNF003280: 'YNNJ2',
  FBJNF003290: 'YNNJ2',
  FBJNF003300: 'YNNB2',
  FBJNF003310: 'YNNJ9',
  FBJNF003320: 'YNNB',
  FBJNF004000: 'YNV',
  FBJNF005000: 'YNTP',
  FBJNF006000: 'YNA',
  FBJNF006010: 'YNA',
  FBJNF006020: 'YNA',
  FBJNF006030: 'YNPJ',
  FBJNF006040: 'YNA',
  FBJNF006050: 'YNA',
  FBJNF006060: 'YNA',
  FBJNF006070: 'YNA',
  FBJNF007000: 'YNB',
  FBJNF007010: 'YNB',
  FBJNF007020: 'YNB',
  FBJNF007030: 'YNB',
  FBJNF007040: 'YNB',
  FBJNF007050: 'YNB',
  FBJNF007060: 'YNB',
  FBJNF007070: 'YNB',
  FBJNF007080: 'YNB',
  FBJNF007090: 'YNB',
  FBJNF007100: 'YNB',
  FBJNF007110: 'YNB',
  FBJNF007120: 'YNB',
  FBJNF008000: 'YNX',
  FBJNF009000: 'YNMH',
  FBJNF010000: 'YNPK',
  FBJNF011000: 'YNK',
  FBJNF012000: 'YPMT6',
  FBJNF012010: 'YNVU',
  FBJNF012030: 'YPMT6',
  FBJNF012040: 'YPMT6',
  FBJNF012050: 'YPMT6',
  FBJNF013000: 'YBL',
  FBJNF013010: 'YBLA',
  FBJNF013020: 'YBLD',
  FBJNF013030: 'YBLC',
  FBJNF013040: 'YNPK',
  FBJNF013050: 'YBLF',
  FBJNF013060: 'YBLN1',
  FBJNF013070: 'YBLH',
  FBJNF013080: 'YBLJ',
  FBJNF013090: 'YBLJ',
  FBJNF013100: 'YBLN1',
  FBJNF013110: 'YNTA',
  FBJNF014000: 'YNPC',
  FBJNF015000: 'YNPH',
  FBJNF016000: 'YNG',
  FBJNF017000: 'YND',
  FBJNF018010: 'YNM',
  FBJNF018020: 'YNM',
  FBJNF018030: 'YNM',
  FBJNF018040: 'YNM',
  FBJNF019000: 'YXF',
  FBJNF019010: 'YXF',
  FBJNF019020: 'YXF',
  FBJNF019030: 'YXF',
  FBJNF019040: 'YXF',
  FBJNF019050: 'YXF',
  FBJNF019060: 'YXF',
  FBJNF019070: 'YXF',
  FBJNF019080: 'YXFD',
  FBJNF019090: 'YXF',
  FBJNF020000: 'YPCK2',
  FBJNF020010: 'YPCK2',
  FBJNF020020: 'YPCK2',
  FBJNF020030: 'YPCK2',
  FBJNF021000: 'YNV',
  FBJNF021010: 'YNV',
  FBJNF021020: 'YNV',
  FBJNF021030: 'YNV',
  FBJNF021040: 'YNVP',
  FBJNF021050: 'YNG',
  FBJNF021060: 'YNVU',
  FBJNF021070: 'YNVP',
  FBJNF022000: 'YNP',
  FBJNF023000: 'YNMF',
  FBJNF024000: 'YXA',
  FBJNF024010: 'YXA',
  FBJNF024020: 'YXA',
  FBJNF024030: 'YXA',
  FBJNF024040: 'YXA',
  FBJNF024050: 'YXA',
  FBJNF024060: 'YXA',
  FBJNF024070: 'YXK',
  FBJNF024080: 'YXR',
  FBJNF024090: 'YXAX',
  FBJNF024100: 'YXJ',
  FBJNF024110: 'YBLM',
  FBJNF024120: 'YXA',
  FBJNF025000: 'YNH',
  FBJNF025010: 'YNH',
  FBJNF025020: 'YNH',
  FBJNF025030: 'YNH',
  FBJNF025040: 'YNH',
  FBJNF025050: 'YNH',
  FBJNF025060: 'YNH',
  FBJNF025070: 'YNH',
  FBJNF025080: 'YNHD',
  FBJNF025090: 'YNH',
  FBJNF025100: 'YNH',
  FBJNF025110: 'YNH',
  FBJNF025120: 'YNH',
  FBJNF025130: 'YNJ',
  FBJNF025140: 'YNH',
  FBJNF025150: 'YNH',
  FBJNF025160: 'YNH',
  FBJNF025170: 'YNH',
  FBJNF025180: 'YNH',
  FBJNF025190: 'YNH',
  FBJNF025200: 'YNH',
  FBJNF025210: 'YNH',
  FBJNF025230: 'YNH',
  FBJNF025240: 'YNH',
  FBJNF025250: 'YNH',
  FBJNF025260: 'YNMC',
  FBJNF025270: 'YNH',
  FBJNF026000: 'YNMC',
  FBJNF026010: 'YNRM',
  FBJNF026020: 'YNRM',
  FBJNF026030: 'YNMC',
  FBJNF026050: 'YNMC',
  FBJNF026060: 'YNMC',
  FBJNF026070: 'YNMC',
  FBJNF026080: 'YNMC',
  FBJNF026090: 'YNR',
  FBJNF026100: 'YN',
  FBJNF026110: 'YNRJ',
  FBJNF026120: 'YNRJ',
  FBJNF026130: 'YNMC',
  FBJNF027000: 'YNP',
  FBJNF028000: 'YNU',
  FBJNF028010: 'YNUC',
  FBJNF028020: 'YNU',
  FBJNF029000: 'YPC',
  FBJNF029010: 'YPCA2',
  FBJNF029020: 'YPCA4',
  FBJNF029030: 'YPCA22',
  FBJNF029040: 'YPCA4',
  FBJNF029050: 'YXK',
  FBJNF030000: 'YNKC',
  FBJNF031000: 'YNMK',
  FBJNF032000: 'YNML',
  FBJNF033000: 'YNML',
  FBJNF034000: 'YNL',
  FBJNF035000: 'YPMF',
  FBJNF035020: 'YPMF',
  FBJNF035030: 'YPMF',
  FBJNF035040: 'YPMF',
  FBJNF035050: 'YPMF',
  FBJNF036000: 'YNC',
  FBJNF036010: 'YNC',
  FBJNF036020: 'YNC',
  FBJNF036030: 'YNC',
  FBJNF036040: 'YNC',
  FBJNF036050: 'YNC',
  FBJNF036060: 'YNC',
  FBJNF036070: 'YNC',
  FBJNF036080: 'YNCS',
  FBJNF036090: 'YNC',
  FBJNF037010: 'YNNV',
  FBJNF037020: 'YXZG',
  FBJNF037030: 'YNNT',
  FBJNF037040: 'YNNT',
  FBJNF037050: 'YNNA',
  FBJNF037060: 'YNNV',
  FBJNF037070: 'YNNB1',
  FBJNF037080: 'YNNV',
  FBJNF038000: 'YNM',
  FBJNF038010: 'YNM',
  FBJNF038020: 'YNM',
  FBJNF038030: 'YNM',
  FBJNF038040: 'YNM',
  FBJNF038050: 'YNM',
  FBJNF038060: 'YNM',
  FBJNF038070: 'YNM',
  FBJNF038080: 'YNM',
  FBJNF038090: 'YNM',
  FBJNF038100: 'YNM',
  FBJNF038120: 'YNM',
  FBJNF039000: 'YND',
  FBJNF039010: 'YND',
  FBJNF039020: 'YNDB',
  FBJNF039030: 'YNF',
  FBJNF039040: 'YNF',
  FBJNF039050: 'YND',
  FBJNF040000: 'YPJL',
  FBJNF041000: 'YNA',
  FBJNF042000: 'YDP',
  FBJNF042010: 'YDP',
  FBJNF043000: 'YNKA',
  FBJNF044000: 'YPJJ5',
  FBJNF045000: 'YPCA21',
  FBJNF046000: 'YPCA21',
  FBJNF047000: 'YPCA21',
  FBJNF048000: 'YR',
  FBJNF048010: 'YRE',
  FBJNF048020: 'YRW',
  FBJNF048030: 'YRD',
  FBJNF048040: 'YRE',
  FBJNF048050: 'YRD',
  FBJNF049000: 'YNR',
  FBJNF049010: 'YNRX',
  FBJNF049020: 'YNRX',
  FBJNF049040: 'YNRX',
  FBJNF049080: 'YNRM',
  FBJNF049090: 'YNRR',
  FBJNF049100: 'YNRP',
  FBJNF049110: 'YNRJ',
  FBJNF049120: 'YNRM',
  FBJNF049130: 'YNRM',
  FBJNF049140: 'YNRX',
  FBJNF049150: 'YNRX',
  FBJNF049170: 'YNRX',
  FBJNF049180: 'YNRM',
  FBJNF049190: 'YNRM',
  FBJNF049200: 'YNRM',
  FBJNF049210: 'YNRM',
  FBJNF049220: 'YNRM',
  FBJNF049240: 'YNRM',
  FBJNF049250: 'YNRM',
  FBJNF049260: 'YNRM',
  FBJNF049280: 'YNRM',
  FBJNF049290: 'YNRM',
  FBJNF049310: 'YNRM',
  FBJNF050000: 'YNGL',
  FBJNF051000: 'YNT',
  FBJNF051010: 'YPMT',
  FBJNF051020: 'YPMT',
  FBJNF051030: 'YNTA',
  FBJNF051040: 'YNNZ',
  FBJNF051050: 'YNT',
  FBJNF051060: 'YNNT',
  FBJNF051070: 'YNT',
  FBJNF051080: 'YNNV',
  FBJNF051090: 'YPMT',
  FBJNF051100: 'YNNC',
  FBJNF051110: 'YNTD',
  FBJNF051120: 'YNTG',
  FBJNF051130: 'YNTG',
  FBJNF051140: 'YNT',
  FBJNF051150: 'YNT',
  FBJNF051160: 'YNNV',
  FBJNF051170: 'YNT',
  FBJNF051180: 'YNNV',
  FBJNF051190: 'YNT',
  FBJNF052000: 'YPJJ',
  FBJNF052010: 'YPJJ',
  FBJNF052020: 'YNMC',
  FBJNF052030: 'YN',
  FBJNF052040: 'YPJJ',
  FBJNF053000: 'YX',
  FBJNF053010: 'YX',
  FBJNF053020: 'YXHL',
  FBJNF053030: 'YXG',
  FBJNF053040: 'YXJ',
  FBJNF053050: 'YXE',
  FBJNF053060: 'YXHB',
  FBJNF053070: 'YXZ',
  FBJNF053080: 'YXHL',
  FBJNF053090: 'YX',
  FBJNF053100: 'YX',
  FBJNF053110: 'YXQ',
  FBJNF053120: 'YXQ',
  FBJNF053140: 'YXN',
  FBJNF053160: 'YXD',
  FBJNF053170: 'YXQ',
  FBJNF053180: 'YXK',
  FBJNF053200: 'YX',
  FBJNF053210: 'YXQ',
  FBJNF053220: 'YXQ',
  FBJNF053230: 'YXK',
  FBJNF053240: 'YXZ',
  FBJNF054000: 'YNW',
  FBJNF054010: 'YNWD3',
  FBJNF054020: 'YNWD4',
  FBJNF054030: 'YNW',
  FBJNF054040: 'YNWY',
  FBJNF054050: 'YNWD2',
  FBJNF054060: 'YNWG',
  FBJNF054070: 'YNWM',
  FBJNF054080: 'YNW',
  FBJNF054100: 'YNW',
  FBJNF054110: 'YNW',
  FBJNF054120: 'YNWD',
  FBJNF054130: 'YNWD1',
  FBJNF054140: 'YNWG',
  FBJNF054150: 'YNWW',
  FBJNF054160: 'YNWM',
  FBJNF054170: 'YNW',
  FBJNF054180: 'YNW',
  FBJNF054190: 'YNWM',
  FBJNF054200: 'YNWY',
  FBJNF054210: 'YNWY',
  FBJNF054220: 'YNW',
  FBJNF054230: 'YNWD',
  FBJNF055000: 'YPWL',
  FBJNF055010: 'YNL',
  FBJNF055030: 'YPZ',
  FBJNF056000: 'YNVD',
  FBJNF057000: 'YNTR',
  FBJNF057010: 'YNTR',
  FBJNF057020: 'YNTR',
  FBJNF057030: 'YNTR',
  FBJNF057040: 'YNTR',
  FBJNF057050: 'YNTR',
  FBJNF058000: 'YNM',
  FBJNF059000: 'YNPJ',
  FBJNF060000: 'YNK',
  FBJNF061000: 'YPMT',
  FBJNF061010: 'YNTD',
  FBJNF062000: 'YNUC',
  FBJNF062010: 'YNUC',
  FBJNF062020: 'YNUC',
  FBJNF063000: 'YNL',
  FBJNF064000: 'YN',
  FBJUV000000: 'YFB',
  FBJUV001000: 'YFC',
  FBJUV001010: 'YFC',
  FBJUV001020: 'YFC',
  FBJUV002000: 'YFP',
  FBJUV002010: 'YFP',
  FBJUV002020: 'YFP',
  FBJUV002030: 'YFP',
  FBJUV002040: 'YFP',
  FBJUV002050: 'YFP',
  FBJUV002060: 'YFP',
  FBJUV002070: 'YFP',
  FBJUV002080: 'YFP',
  FBJUV002090: 'YFP',
  FBJUV002100: 'YFP',
  FBJUV002110: 'YFP',
  FBJUV002120: 'YFP',
  FBJUV002130: 'YFP',
  FBJUV002140: 'YFP',
  FBJUV002150: 'YFP',
  FBJUV002160: 'YFP',
  FBJUV002170: 'YFP',
  FBJUV002180: 'YFP',
  FBJUV002190: 'YFP',
  FBJUV002200: 'YFP',
  FBJUV002210: 'YFP',
  FBJUV002220: 'YFP',
  FBJUV002230: 'YFP',
  FBJUV002240: 'YFP',
  FBJUV002250: 'YFP',
  FBJUV002260: 'YFP',
  FBJUV002280: 'YFP',
  FBJUV002290: 'YFP',
  FBJUV002300: 'YFP',
  FBJUV002310: 'YFP',
  FBJUV002320: 'YFP',
  FBJUV002330: 'YFP',
  FBJUV002340: 'YFP',
  FBJUV003000: 'YFB',
  FBJUV004000: 'YFX',
  FBJUV005000: 'YFB',
  FBJUV006000: 'YFB',
  FBJUV007000: 'YFA',
  FBJUV008000: 'YFB',
  FBJUV008010: 'YFB',
  FBJUV008020: 'YFG',
  FBJUV008030: 'YFB',
  FBJUV009000: 'YFB',
  FBJUV009010: 'YFB',
  FBJUV009020: 'YFB',
  FBJUV009030: 'YFB',
  FBJUV009040: 'YFB',
  FBJUV009050: 'YFB',
  FBJUV009060: 'YFB',
  FBJUV009070: 'YFB',
  FBJUV009080: 'YFB',
  FBJUV009090: 'YFB',
  FBJUV009100: 'YFB',
  FBJUV009110: 'YFB',
  FBJUV009120: 'YFB',
  FBJUV010000: 'YBCS1',
  FBJUV011010: 'YFB',
  FBJUV011020: 'YFB',
  FBJUV011030: 'YFB',
  FBJUV011040: 'YFB',
  FBJUV012000: 'YFJ',
  FBJUV012020: 'YFJ',
  FBJUV012030: 'YFJ',
  FBJUV012040: 'YFJ',
  FBJUV013000: 'YFN',
  FBJUV013010: 'YFN',
  FBJUV013020: 'YFN',
  FBJUV013030: 'YFN',
  FBJUV013040: 'YFN',
  FBJUV013050: 'YFN',
  FBJUV013060: 'YFN',
  FBJUV013070: 'YFN',
  FBJUV013080: 'YFN',
  FBJUV013090: 'YFN',
  FBJUV014000: 'YFB',
  FBJUV015000: 'YFB',
  FBJUV015010: 'YFB',
  FBJUV015020: 'YFB',
  FBJUV016000: 'YFT',
  FBJUV016010: 'YFT',
  FBJUV016020: 'YFT',
  FBJUV016030: 'YFT',
  FBJUV016040: 'YFT',
  FBJUV016050: 'YFT',
  FBJUV016060: 'YFT',
  FBJUV016070: 'YFT',
  FBJUV016080: 'YFT',
  FBJUV016090: 'YFT',
  FBJUV016100: 'YFT',
  FBJUV016110: 'YFT',
  FBJUV016120: 'YFT',
  FBJUV016140: 'YFT',
  FBJUV016150: 'YFT',
  FBJUV016160: 'YFT',
  FBJUV016170: 'YFT',
  FBJUV016180: 'YFT',
  FBJUV016190: 'YFT',
  FBJUV016200: 'YFT',
  FBJUV016210: 'YFT',
  FBJUV017000: 'YFB',
  FBJUV017010: 'YFB',
  FBJUV017020: 'YFB',
  FBJUV017030: 'YFB',
  FBJUV017050: 'YFB',
  FBJUV017060: 'YFB',
  FBJUV017070: 'YFB',
  FBJUV017080: 'YFB',
  FBJUV017090: 'YFB',
  FBJUV017100: 'YFB',
  FBJUV017110: 'YFB',
  FBJUV017120: 'YFB',
  FBJUV017130: 'YFB',
  FBJUV018000: 'YFD',
  FBJUV019000: 'YFQ',
  FBJUV020000: 'YFCA',
  FBJUV022000: 'YFJ',
  FBJUV022010: 'YFJ',
  FBJUV022020: 'YFJ',
  FBJUV022030: 'YFJ',
  FBJUV023000: 'YFB',
  FBJUV024000: 'YFB',
  FBJUV025000: 'YFB',
  FBJUV026000: 'YFM',
  FBJUV027000: 'YFB',
  FBJUV028000: 'YFCF',
  FBJUV029000: 'YFP',
  FBJUV029010: 'YFP',
  FBJUV029020: 'YFP',
  FBJUV030000: 'YFB',
  FBJUV030010: 'YFB',
  FBJUV030020: 'YFB',
  FBJUV030030: 'YFB',
  FBJUV030040: 'YFB',
  FBJUV030050: 'YFB',
  FBJUV030060: 'YFB',
  FBJUV030080: 'YFB',
  FBJUV030090: 'YFB',
  FBJUV030100: 'YFB',
  FBJUV030110: 'YFB',
  FBJUV030120: 'YFB',
  FBJUV031000: 'YFB',
  FBJUV031010: 'YFB',
  FBJUV031020: 'YFB',
  FBJUV031030: 'YFB',
  FBJUV031040: 'YFB',
  FBJUV031050: 'YFB',
  FBJUV031060: 'YFB',
  FBJUV032000: 'YFR',
  FBJUV032010: 'YFR',
  FBJUV032020: 'YFR',
  FBJUV032030: 'YFR',
  FBJUV032040: 'YFR',
  FBJUV032060: 'YFR',
  FBJUV032070: 'YFR',
  FBJUV032080: 'YFR',
  FBJUV032090: 'YFR',
  FBJUV032100: 'YFR',
  FBJUV032110: 'YFR',
  FBJUV032120: 'YFR',
  FBJUV032140: 'YFR',
  FBJUV032150: 'YFR',
  FBJUV032160: 'YFR',
  FBJUV032170: 'YFR',
  FBJUV032180: 'YFR',
  FBJUV032190: 'YFR',
  FBJUV033000: 'YFK',
  FBJUV033010: 'YFK',
  FBJUV033020: 'YFK',
  FBJUV033040: 'YFK',
  FBJUV033050: 'YFK',
  FBJUV033060: 'YFK',
  FBJUV033070: 'YFK',
  FBJUV033080: 'YFK',
  FBJUV033090: 'YFK',
  FBJUV033100: 'YFK',
  FBJUV033110: 'YFK',
  FBJUV033120: 'YFK',
  FBJUV033140: 'YFK',
  FBJUV033150: 'YFK',
  FBJUV033160: 'YFK',
  FBJUV033170: 'YFK',
  FBJUV033180: 'YFK',
  FBJUV033190: 'YFK',
  FBJUV033200: 'YFK',
  FBJUV033220: 'YFK',
  FBJUV033230: 'YFK',
  FBJUV033240: 'YFK',
  FBJUV034000: 'YFB',
  FBJUV035000: 'YFS',
  FBJUV036000: 'YFB',
  FBJUV037000: 'YFH',
  FBJUV038000: 'YFU',
  FBJUV039000: 'YFB',
  FBJUV039010: 'YFB',
  FBJUV039020: 'YFB',
  FBJUV039030: 'YFB',
  FBJUV039040: 'YFB',
  FBJUV039050: 'YFB',
  FBJUV039060: 'YFB',
  FBJUV039070: 'YFB',
  FBJUV039090: 'YFB',
  FBJUV039100: 'YFB',
  FBJUV039120: 'YFB',
  FBJUV039130: 'YFB',
  FBJUV039140: 'YFB',
  FBJUV039150: 'YFB',
  FBJUV039170: 'YFB',
  FBJUV039180: 'YFB',
  FBJUV039190: 'YFM',
  FBJUV039200: 'YFB',
  FBJUV039210: 'YFB',
  FBJUV039220: 'YFB',
  FBJUV039230: 'YFB',
  FBJUV039240: 'YFB',
  FBJUV039250: 'YFB',
  FBJUV039270: 'YFB',
  FBJUV040000: 'YFB',
  FBJUV041000: 'YFB',
  FBJUV041010: 'YFB',
  FBJUV041020: 'YFB',
  FBJUV041030: 'YFB',
  FBJUV041050: 'YFB',
  FBJUV042000: 'YFC',
  FBJUV046000: 'YFH',
  FBJUV047000: 'YFB',
  FBJUV048000: 'YFB',
  FBJUV049000: 'YFB',
  FBJUV050000: 'YFB',
  FBJUV051000: 'YBCS2',
  FBJUV052000: 'YFH',
  FBJUV053000: 'YFG',
  FBJUV054000: 'YBG',
  FBJUV055000: 'YBLB',
  FBJUV056000: 'YFG',
  FBJUV057000: 'YFV',
  FBLAN000000: 'CB',
  FBLAN001000: 'CFLA',
  FBLAN002000: 'CBW',
  FBLAN004000: 'GTC',
  FBLAN005000: 'CBV',
  FBLAN006000: 'CJBG',
  FBLAN007000: 'WFU',
  FBLAN008000: 'KNTP2',
  FBLAN009000: 'CF',
  FBLAN009010: 'CFF',
  FBLAN009020: 'CFK',
  FBLAN009030: 'CFG',
  FBLAN009040: 'CFD',
  FBLAN009050: 'CFB',
  FBLAN009060: 'CFK',
  FBLAN010000: 'CFC',
  FBLAN011000: 'CFH',
  FBLAN012000: 'CJBR',
  FBLAN013000: 'CJCR',
  FBLAN014000: 'CB',
  FBLAN015000: 'CFG',
  FBLAN016000: 'CFG',
  FBLAN017000: 'CFZ',
  FBLAN018000: 'CJCK',
  FBLAN019000: 'CJC',
  FBLAN020000: 'CJ',
  FBLAN021000: 'CJBG',
  FBLAN022000: 'CBW',
  FBLAN023000: 'CFP',
  FBLAN024000: 'CFF',
  FBLAN025000: 'GLC',
  FBLAN025010: 'GLC',
  FBLAN025020: 'GLC',
  FBLAN025030: 'GLK',
  FBLAN025040: 'GLH',
  FBLAN025050: 'GLM',
  FBLAN026000: 'CBP',
  FBLAN027000: 'KNTP',
  FBLAN028000: 'CBW',
  FBLAW000000: 'LA',
  FBLAW001000: 'LNDB',
  FBLAW007000: 'LNPB',
  FBLAW009000: 'LNC',
  FBLAW013000: 'LAFC',
  FBLAW018000: 'LNDX',
  FBLAW020000: 'LNTU',
  FBLAW020000N: 'LNT',
  FBLAW027000: 'LNF',
  FBLAW031000: 'LNTQ',
  FBLAW032000: 'LNDA',
  FBLAW034000: 'LNKJ',
  FBLAW038000: 'LNM',
  FBLAW038010: 'LNMK',
  FBLAW038020: 'LNMB',
  FBLAW038030: 'LNMB',
  FBLAW044000: 'LA',
  FBLAW046000: 'LNTJ',
  FBLAW049000: 'LNPN',
  FBLAW050000: 'LNR',
  FBLAW051000: 'LB',
  FBLAW052000N: 'LA',
  FBLAW054000: 'LNH',
  FBLAW055000: 'LNSH',
  FBLAW060000: 'LAZ',
  FBLAW065000: 'LNW',
  FBLAW074000: 'LNS',
  FBLAW075000: 'LNX',
  FBLAW076000: 'LNDB',
  FBLAW078000: 'LNSH',
  FBLAW086000: 'LNU',
  FBLAW093000: 'LNTM',
  FBLAW101000: 'LA',
  FBLAW105000: 'LNCD',
  FBLAW108000: 'LNDS',
  FBLAW109000: 'LNDH',
  FBLAW116000: 'LNDC2',
  FBLCO000000: 'DNT',
  FBLCO001000: 'DNT',
  FBLCO002000: 'DNT',
  FBLCO002010: 'DNT',
  FBLCO003000: 'DB',
  FBLCO004000: 'DNT',
  FBLCO005000: 'DNT',
  FBLCO006000: 'DNT',
  FBLCO007000: 'DNT',
  FBLCO008000: 'DNT',
  FBLCO009000: 'DNT',
  FBLCO010000: 'DNL',
  FBLCO011000: 'DND',
  FBLCO012000: 'DNT',
  FBLCO013000: 'DNT',
  FBLCO014000: 'DNT',
  FBLIT000000: 'DS',
  FBMAT000000: 'PB',
  FBMAT002000: 'PBF',
  FBMAT002010: 'PBF',
  FBMAT002030: 'PBF',
  FBMAT002040: 'PBF',
  FBMAT002050: 'PBF',
  FBMAT003000: 'PBW',
  FBMAT004000: 'PBC',
  FBMAT005000: 'PBKA',
  FBMAT006000: 'PBC',
  FBMAT007000: 'PBKJ',
  FBMAT008000: 'PBD',
  FBMAT009000: 'PBD',
  FBMAT011000: 'PBUD',
  FBMAT012000: 'PBM',
  FBMAT012010: 'PBMW',
  FBMAT012020: 'PBMS',
  FBMAT012030: 'PBMP',
  FBMAT012040: 'PBML',
  FBMAT013000: 'PBV',
  FBMAT014000: 'PBG',
  FBMAT015000: 'PBX',
  FBMAT016000: 'PB',
  FBMAT017000: 'PBUH',
  FBMAT018000: 'PBCD',
  FBMAT019000: 'PBF',
  FBMAT020000: 'PDD',
  FBMAT021000: 'PBCN',
  FBMAT022000: 'PBH',
  FBMAT023000: 'PBJ',
  FBMAT025000: 'PB',
  FBMAT026000: 'PB',
  FBMAT027000: 'PB',
  FBMAT028000: 'PBCH',
  FBMAT029000: 'PBT',
  FBMAT029010: 'PBTB',
  FBMAT029020: 'PBT',
  FBMAT029030: 'PBT',
  FBMAT030000: 'PB',
  FBMAT031000: 'PBKF',
  FBMAT032000: 'PBMB',
  FBMAT033000: 'PBK',
  FBMAT034000: 'PBK',
  FBMAT036000: 'PBV',
  FBMAT037000: 'PBKF',
  FBMAT038000: 'PBP',
  FBMAT039000: 'PB',
  FBMED000000: 'MB',
  FBMED001000: 'MX',
  FBMED002000: 'MBPM',
  FBMED003000: 'MQ',
  FBMED003010: 'MQF',
  FBMED003020: 'MX',
  FBMED003030: 'MJ',
  FBMED003040: 'MBG',
  FBMED003050: 'MQT',
  FBMED003060: 'MQS',
  FBMED003070: 'MKS',
  FBMED003080: 'MJL',
  FBMED003090: 'MX',
  FBMED004000: 'MX',
  FBMED005000: 'MFC',
  FBMED006000: 'MKA',
  FBMED007000: 'MJPD',
  FBMED008000: 'MF',
  FBMED009000: 'MF',
  FBMED010000: 'MJD',
  FBMED011000: 'MQ',
  FBMED012000: 'MJCL2',
  FBMED013000: 'MXH',
  FBMED014000: 'MJ',
  FBMED015000: 'MKP',
  FBMED016000: 'MKE',
  FBMED016010: 'MKE',
  FBMED016020: 'MKE',
  FBMED016030: 'MKE',
  FBMED016040: 'MKE',
  FBMED016050: 'MKEP',
  FBMED017000: 'MJK',
  FBMED018000: 'MJA',
  FBMED019000: 'MKS',
  FBMED020000: 'MR',
  FBMED021000: 'MBNH3',
  FBMED022000: 'MJC',
  FBMED022020: 'MJCJ2',
  FBMED022090: 'MJCJ',
  FBMED023000: 'MKG',
  FBMED024000: 'MR',
  FBMED025000: 'MFKC3',
  FBMED026000: 'MKP',
  FBMED027000: 'MJG',
  FBMED028000: 'MBNS',
  FBMED029000: 'MBPA',
  FBMED030000: 'MKT',
  FBMED031000: 'MJH',
  FBMED032000: 'MKN',
  FBMED033000: 'MKC',
  FBMED034000: 'MJ',
  FBMED035000: 'MBP',
  FBMED036000: 'MBQ',
  FBMED037000: 'MBNC',
  FBMED038000: 'MJF',
  FBMED039000: 'MBX',
  FBMED040000: 'MX',
  FBMED041000: 'MQ',
  FBMED042000: 'MKB',
  FBMED043000: 'MBP',
  FBMED044000: 'MJCM',
  FBMED045000: 'MJ',
  FBMED047000: 'MBGL',
  FBMED048000: 'MBG',
  FBMED049000: 'MBPR',
  FBMED050000: 'MBDC',
  FBMED051000: 'MBF',
  FBMED052000: 'MKFM',
  FBMED055000: 'MJR',
  FBMED056000: 'MKJ',
  FBMED057000: 'MKJ',
  FBMED058000: 'MQC',
  FBMED058010: 'MQCL',
  FBMED058020: 'MQCA',
  FBMED058030: 'MQCL2',
  FBMED058040: 'MQCL1',
  FBMED058050: 'MQCA',
  FBMED058060: 'MQCL4',
  FBMED058070: 'MQCX',
  FBMED058080: 'MQCL3',
  FBMED058090: 'MQCW',
  FBMED058100: 'MQCL',
  FBMED058110: 'MQCZ',
  FBMED058120: 'MQCL',
  FBMED058140: 'MQCH',
  FBMED058150: 'MQCL',
  FBMED058160: 'MQCL',
  FBMED058170: 'MQCM',
  FBMED058180: 'MQCL5',
  FBMED058190: 'MQC',
  FBMED058200: 'MQCB',
  FBMED058210: 'MQC',
  FBMED058220: 'MQCL6',
  FBMED059000: 'MBPN',
  FBMED060000: 'MBNH3',
  FBMED061000: 'MKVP',
  FBMED062000: 'MJCL',
  FBMED063000: 'MJQ',
  FBMED064000: 'MQR',
  FBMED065000: 'MJE',
  FBMED066000: 'MJP',
  FBMED067000: 'MKF',
  FBMED068000: 'MKF',
  FBMED069000: 'MKD',
  FBMED070000: 'MKDN',
  FBMED071000: 'MKG',
  FBMED072000: 'MQP',
  FBMED073000: 'MQS',
  FBMED074000: 'MBDP',
  FBMED075000: 'MFG',
  FBMED076000: 'MBN',
  FBMED077000: 'MQWP',
  FBMED078000: 'MBN',
  FBMED079000: 'MJ',
  FBMED080000: 'MKR',
  FBMED081000: 'MR',
  FBMED082000: 'MFKC',
  FBMED083000: 'MJM',
  FBMED084000: 'MKW',
  FBMED085000: 'MN',
  FBMED085010: 'MNN',
  FBMED085020: 'MKEP',
  FBMED085030: 'MNP',
  FBMED085040: 'MNH',
  FBMED085050: 'MNJ',
  FBMED085060: 'MNG',
  FBMED086000: 'MRG',
  FBMED087000: 'MQ',
  FBMED088000: 'MJS',
  FBMED089000: 'MZ',
  FBMED089010: 'MZDH',
  FBMED089020: 'MZD',
  FBMED089030: 'MZC',
  FBMED090000: 'MBGR',
  FBMED091000: 'MJC',
  FBMED092000: 'MXH',
  FBMED093000: 'MKAL',
  FBMED094000: 'MKD',
  FBMED095000: 'MBPM',
  FBMED096000: 'MKGT',
  FBMED097000: 'MKVT',
  FBMED098000: 'MKSF',
  FBMED100000: 'MQK',
  FBMED101000: 'MRT',
  FBMED102000: 'MBPK',
  FBMED103000: 'MKFP',
  FBMED104000: 'MBD',
  FBMED105000: 'MKL',
  FBMED105010: 'MKL',
  FBMED105020: 'MKGW',
  FBMED106000: 'MBGR',
  FBMED107000: 'MFN',
  FBMED108000: 'MBG',
  FBMED109000: 'MB',
  FBMED110000: 'MFCH',
  FBMED111000: 'MKZF',
  FBMED112000: 'MJ',
  FBMED113000: 'MQ',
  FBMUS000000: 'AV',
  FBMUS001000: 'AV',
  FBMUS002000: 'AVLA',
  FBMUS003000: 'AVLP',
  FBMUS004000: 'AV',
  FBMUS005000: 'AVLA',
  FBMUS006000: 'AVLA',
  FBMUS007000: 'AVA',
  FBMUS008000: 'AVS',
  FBMUS009000: 'AVLK',
  FBMUS010000: 'AVLT',
  FBMUS011000: 'AVLP',
  FBMUS012000: 'AVD',
  FBMUS013000: 'AVLX',
  FBMUS014000: 'AV',
  FBMUS015000: 'AVA',
  FBMUS016000: 'AVS',
  FBMUS017000: 'AVLT',
  FBMUS018000: 'AVLK',
  FBMUS019000: 'AVLP',
  FBMUS020000: 'AVC',
  FBMUS021000: 'AVLK',
  FBMUS022000: 'AVS',
  FBMUS023000: 'AVR',
  FBMUS023010: 'AVRN',
  FBMUS023020: 'AVRJ',
  FBMUS023030: 'AVRG',
  FBMUS023040: 'AVRL',
  FBMUS023050: 'AVRN',
  FBMUS023060: 'AVRL1',
  FBMUS024000: 'AVLW',
  FBMUS025000: 'AVLP',
  FBMUS026000: 'AVL',
  FBMUS027000: 'AVLP',
  FBMUS028000: 'AVLF',
  FBMUS029000: 'AVLP',
  FBMUS030000: 'AVLP',
  FBMUS031000: 'AVLP',
  FBMUS032000: 'AVX',
  FBMUS033000: 'AV',
  FBMUS035000: 'AVLP',
  FBMUS036000: 'AVLW',
  FBMUS037000: 'AVQ',
  FBMUS037010: 'AVQ',
  FBMUS037020: 'AVQ',
  FBMUS037030: 'AVQ',
  FBMUS037040: 'AVQ',
  FBMUS037050: 'AVQ',
  FBMUS037060: 'AVQ',
  FBMUS037070: 'AVQ',
  FBMUS037080: 'AVQ',
  FBMUS037090: 'AVQ',
  FBMUS037100: 'AVQS',
  FBMUS037110: 'AVQS',
  FBMUS038000: 'AVA',
  FBMUS039000: 'AVLP',
  FBMUS040000: 'AVS',
  FBMUS041000: 'AVA',
  FBMUS042000: 'AVSA',
  FBMUS045000: 'AVLA',
  FBMUS046000: 'AVLP',
  FBMUS047000: 'AVLP',
  FBMUS048000: 'AVLK',
  FBMUS048010: 'AVLK',
  FBMUS048020: 'AVLK',
  FBMUS048030: 'AVLK',
  FBMUS049000: 'AVL',
  FBMUS050000: 'AVN',
  FBMUS051000: 'AVLC',
  FBMUS052000: 'AVQ',
  FBNAT000000: 'WN',
  FBNAT001000: 'WNC',
  FBNAT002000: 'WNCF',
  FBNAT003000: 'WNCF',
  FBNAT004000: 'WNCB',
  FBNAT005000: 'WNCN',
  FBNAT007000: 'WNA',
  FBNAT010000: 'RNC',
  FBNAT011000: 'RNK',
  FBNAT012000: 'WNCS',
  FBNAT013000: 'WNP',
  FBNAT014000: 'WNW',
  FBNAT017000: 'WNCN',
  FBNAT018000: 'WNW',
  FBNAT019000: 'WNCF',
  FBNAT022000: 'WNP',
  FBNAT023000: 'RNR',
  FBNAT025000: 'WNW',
  FBNAT028000: 'WNCK',
  FBNAT029000: 'WNW',
  FBNAT031000: 'WNCS1',
  FBNAT033000: 'WNX',
  FBNAT034000: 'WNP',
  FBNAT036000: 'WNWM',
  FBNAT038000: 'RNF',
  FBNAT039000: 'JBFU',
  FBNAT041000: 'WNW',
  FBNAT042000: 'WNCF',
  FBNAT043000: 'WNCB',
  FBNAT044000: 'WNCF',
  FBNAT046000: 'RNKH1',
  FBOCC000000: 'VX',
  FBOCC002000: 'VXFA',
  FBOCC003000: 'VXPS',
  FBOCC004000: 'VXPC',
  FBOCC005000: 'VXF',
  FBOCC006000: 'VXN',
  FBOCC010000: 'VXM',
  FBOCC011000: 'VXH',
  FBOCC015000: 'VXFN',
  FBOCC018000: 'VXQ',
  FBOCC020000: 'VX',
  FBOCC025000: 'VXQ',
  FBOCC028000: 'VXWM',
  FBOCC032000: 'VXPS',
  FBOCC036000: 'QRVK',
  FBOCC036010: 'QRST',
  FBOCC036030: 'VXWS',
  FBOCC037000: 'VXV',
  FBPER000000: 'AT',
  FBPER001000: 'ATDC',
  FBPER002000: 'ATX',
  FBPER003000: 'ATQ',
  FBPER003010: 'ATQL',
  FBPER003020: 'ATQZ',
  FBPER003030: 'ATQT',
  FBPER003040: 'ATQT',
  FBPER003050: 'ATQC',
  FBPER003060: 'ATQ',
  FBPER003070: 'ATQ',
  FBPER003080: 'ATQT',
  FBPER004000: 'ATF',
  FBPER004010: 'ATFX',
  FBPER004020: 'ATFG',
  FBPER004030: 'ATFA',
  FBPER004040: 'ATF',
  FBPER004050: 'CBVS',
  FBPER006000: 'ATX',
  FBPER007000: 'ATXM',
  FBPER008000: 'ATL',
  FBPER008010: 'ATL',
  FBPER008020: 'ATL',
  FBPER010000: 'ATJ',
  FBPER010010: 'ATJX',
  FBPER010020: 'ATJ',
  FBPER010030: 'ATJ',
  FBPER010040: 'ATJ',
  FBPER010050: 'CBVS',
  FBPER011000: 'ATD',
  FBPER011010: 'ATDF',
  FBPER011020: 'ATD',
  FBPER011030: 'CBV',
  FBPER011040: 'ATDH',
  FBPER013000: 'ATD',
  FBPER014000: 'AT',
  FBPER015000: 'ATX',
  FBPER016000: 'ATFD',
  FBPER017000: 'ATFV',
  FBPER019000: 'ATX',
  FBPET000000: 'WNG',
  FBPET002000: 'WNGK',
  FBPET003000: 'WNGC',
  FBPET004000: 'WNGD',
  FBPET004020: 'WNGD1',
  FBPET005000: 'WNGF',
  FBPET006000: 'WNGH',
  FBPET011000: 'WNGR',
  FBPHI000000: 'QD',
  FBPHI001000: 'QDTN',
  FBPHI002000: 'QDHA',
  FBPHI003000: 'QDHC',
  FBPHI004000: 'QDTK',
  FBPHI005000: 'QDTQ',
  FBPHI006000: 'QDHR5',
  FBPHI007000: 'QDT',
  FBPHI008000: 'QDTQ',
  FBPHI009000: 'QDH',
  FBPHI010000: 'QDHH',
  FBPHI011000: 'QDTL',
  FBPHI012000: 'QDHF',
  FBPHI013000: 'QDTJ',
  FBPHI014000: 'QD',
  FBPHI015000: 'QDTM',
  FBPHI016000: 'QDHR',
  FBPHI018000: 'QDHR5',
  FBPHI019000: 'QDTS',
  FBPHI020000: 'QDHR3',
  FBPHI021000: 'QD',
  FBPHI022000: 'QRAB',
  FBPHI023000: 'QDHC',
  FBPHI025000: 'QDHC',
  FBPHI026000: 'QDH',
  FBPHI027000: 'QDHR',
  FBPHI028000: 'QDHC',
  FBPHI029000: 'QDHR7',
  FBPHI030000: 'QDHR',
  FBPHI031000: 'QDH',
  FBPHI032000: 'QDHM',
  FBPHI033000: 'QDHC',
  FBPHI034000: 'QDTS',
  FBPHI035000: 'QD',
  FBPHO000000: 'AJ',
  FBPHO001000: 'AJ',
  FBPHO003000: 'AJ',
  FBPHO004000: 'AJC',
  FBPHO004010: 'AJC',
  FBPHO004020: 'AJC',
  FBPHO005000: 'AJ',
  FBPHO006000: 'AJT',
  FBPHO007000: 'AJT',
  FBPHO009000: 'AJ',
  FBPHO010000: 'AJ',
  FBPHO011000: 'AJCD',
  FBPHO011010: 'AJCD',
  FBPHO011020: 'AJCD',
  FBPHO011030: 'AJCD',
  FBPHO012000: 'AJT',
  FBPHO013000: 'AJ',
  FBPHO014000: 'AJC',
  FBPHO015000: 'AJF',
  FBPHO016000: 'AJCP',
  FBPHO017000: 'AJ',
  FBPHO018000: 'AJT',
  FBPHO019000: 'AJ',
  FBPHO020000: 'AJTF',
  FBPHO021000: 'AJ',
  FBPHO022000: 'AJTV',
  FBPHO023000: 'AJ',
  FBPHO023010: 'AJTF',
  FBPHO023020: 'AJCP',
  FBPHO023030: 'AJCX',
  FBPHO023040: 'AJ',
  FBPHO023050: 'AJCX',
  FBPHO023060: 'AJ',
  FBPHO023070: 'AJ',
  FBPHO023080: 'AJ',
  FBPHO023090: 'AJ',
  FBPHO023100: 'AJ',
  FBPHO024000: 'AJT',
  FBPHO025000: 'AJ',
  FBPOE000000: 'DC',
  FBPOL001000: 'JPSF',
  FBPOL002000: 'RPC',
  FBPOL003000: 'JPVC',
  FBPOL004000: 'JPVH',
  FBPOL005000: 'JPFC',
  FBPOL006000: 'JPQ',
  FBPOL007000: 'JPHV',
  FBPOL008000: 'JPHF',
  FBPOL009000: 'JPB',
  FBPOL010000: 'JPA',
  FBPOL011000: 'JPS',
  FBPOL011010: 'JPSD',
  FBPOL011020: 'KCL',
  FBPOL012000: 'JW',
  FBPOL013000: 'KNX',
  FBPOL014000: 'JKSW1',
  FBPOL015000: 'JPL',
  FBPOL016000: 'JPH',
  FBPOL017000: 'JPP',
  FBPOL018000: 'JP',
  FBPOL020000: 'JPR',
  FBPOL021000: 'LBBC',
  FBPOL022000: 'JPHC',
  FBPOL023000: 'KCP',
  FBPOL026000: 'RP',
  FBPOL029000: 'JKS',
  FBPOL031000: 'JPFN',
  FBPOL033000: 'GTQ',
  FBPOL035000: 'JPV',
  FBPOL035010: 'JPVH',
  FBPOL036000: 'JPSH',
  FBPOL037000: 'JPWL',
  FBPOL038000: 'JPQB',
  FBPOL039000: 'JBFV3',
  FBPOL040000: 'JP',
  FBPOL040010: 'JPQ',
  FBPOL040020: 'JP',
  FBPOL040030: 'JPQ',
  FBPOL040040: 'JPR',
  FBPOL041000: 'JPWH',
  FBPOL042000: 'JPF',
  FBPOL042010: 'JPFB',
  FBPOL042020: 'JPFM',
  FBPOL042030: 'JPHX',
  FBPSY000000: 'JM',
  FBPSY002000: 'JMC',
  FBPSY003000: 'JM',
  FBPSY004000: 'JMC',
  FBPSY006000: 'MKMT3',
  FBPSY007000: 'MKM',
  FBPSY008000: 'JMR',
  FBPSY009000: 'JMP',
  FBPSY010000: 'MKMT5',
  FBPSY011000: 'MKZD',
  FBPSY012000: 'JM',
  FBPSY013000: 'JMQ',
  FBPSY014000: 'JMK',
  FBPSY015000: 'JM',
  FBPSY016000: 'JMU',
  FBPSY017000: 'JMH',
  FBPSY020000: 'JMM',
  FBPSY021000: 'JMJ',
  FBPSY022000: 'JMP',
  FBPSY022010: 'JMP',
  FBPSY022020: 'MKJA',
  FBPSY022030: 'JMP',
  FBPSY022040: 'JMP',
  FBPSY022050: 'JMP',
  FBPSY022060: 'JMP',
  FBPSY022070: 'JMP',
  FBPSY023000: 'JMS',
  FBPSY024000: 'JMM',
  FBPSY026000: 'JMAF',
  FBPSY028000: 'MKMT',
  FBPSY029000: 'JM',
  FBPSY030000: 'JMB',
  FBPSY031000: 'JMH',
  FBPSY032000: 'JMB',
  FBPSY034000: 'JMR',
  FBPSY035000: 'JMT',
  FBPSY036000: 'JM',
  FBPSY037000: 'JM',
  FBPSY038000: 'MKZR',
  FBPSY039000: 'JMC',
  FBPSY040000: 'JML',
  FBPSY041000: 'MKMT4',
  FBPSY042000: 'JMBT',
  FBPSY043000: 'JMC',
  FBPSY044000: 'JMC',
  FBPSY045000: 'JMA',
  FBPSY045010: 'JMAL',
  FBPSY045020: 'JMAN',
  FBPSY045030: 'JMA',
  FBPSY045040: 'JMA',
  FBPSY045050: 'JMA',
  FBPSY045060: 'JMAJ',
  FBPSY046000: 'JM',
  FBPSY048000: 'MKMT2',
  FBPSY049000: 'JMP',
  FBPSY050000: 'JM',
  FBREF000000: 'GB',
  FBREF001000: 'GBCY',
  FBREF002000: 'RGX',
  FBREF004000: 'GBCR',
  FBREF006000: 'GBCR',
  FBREF007000: 'GBC',
  FBREF008000: 'CBD',
  FBREF009000: 'GBCT',
  FBREF010000: 'GBA',
  FBREF011000: 'WJX',
  FBREF013000: 'NHTG',
  FBREF015000: 'VS',
  FBREF018000: 'WDKX',
  FBREF019000: 'GBCQ',
  FBREF020000: 'GPS',
  FBREF022000: 'CBF',
  FBREF023000: 'WDKX',
  FBREF024000: 'WJW',
  FBREF025000: 'CB',
  FBREF026000: 'CBW',
  FBREF027000: 'GBCY',
  FBREF028000: 'GBC',
  FBREF030000: 'VSG',
  FBREL000000: 'QR',
  FBREL002000: 'QRMB39',
  FBREL003000: 'QRMB31',
  FBREL006000: 'QRVC',
  FBREL006000N: 'QRMF1',
  FBREL007000: 'QRF',
  FBREL010000: 'QRMB1',
  FBREL018000: 'QRRL1',
  FBREL032000: 'QRD',
  FBREL032010: 'QRAX',
  FBREL037000: 'QRP',
  FBREL040000: 'QRJ',
  FBREL040000N: 'QR',
  FBREL049000: 'QRMB2',
  FBREL050000N: 'QRVJ',
  FBREL053000: 'QRMB3',
  FBREL059000: 'QRMB39',
  FBREL060000N: 'QR',
  FBREL065000: 'QRRL5',
  FBREL070000: 'QRM',
  FBREL073000: 'QRMB32',
  FBREL079000: 'QRMB36',
  FBREL082000: 'QRMB34',
  FBREL088000: 'QRMB37',
  FBREL093000: 'QRMB33',
  FBREL100000: 'QRYX9',
  FBREL110000: 'QRM',
  FBREL114000: 'QRS',
  FBSCI000000: 'PD',
  FBSCI001000: 'PHDS',
  FBSCI004000: 'PG',
  FBSCI005000: 'PHVB',
  FBSCI006000: 'PSG',
  FBSCI007000: 'PSB',
  FBSCI008000: 'PS',
  FBSCI009000: 'PHVN',
  FBSCI010000: 'TCB',
  FBSCI011000: 'PST',
  FBSCI012000: 'PBWS',
  FBSCI013000: 'PN',
  FBSCI013010: 'PNF',
  FBSCI013020: 'PSB',
  FBSCI013030: 'PNK',
  FBSCI013040: 'PNN',
  FBSCI013050: 'PNR',
  FBSCI013060: 'TDC',
  FBSCI015000: 'PGK',
  FBSCI016000: 'PNT',
  FBSCI017000: 'PSF',
  FBSCI018000: 'PHDT',
  FBSCI019000: 'RB',
  FBSCI020000: 'PSAF',
  FBSCI021000: 'PHK',
  FBSCI022000: 'PHK',
  FBSCI023000: 'PDN',
  FBSCI024000: 'PHDY',
  FBSCI025000: 'PSVA',
  FBSCI026000: 'TQ',
  FBSCI027000: 'PSAJ',
  FBSCI028000: 'PDN',
  FBSCI029000: 'PSAK',
  FBSCI030000: 'RG',
  FBSCI031000: 'RBG',
  FBSCI032000: 'PHVG',
  FBSCI033000: 'PHDV',
  FBSCI034000: 'PDX',
  FBSCI036000: 'PSX',
  FBSCI038000: 'PHK',
  FBSCI039000: 'PSPM',
  FBSCI041000: 'PHD',
  FBSCI042000: 'RBP',
  FBSCI043000: 'PDM',
  FBSCI045000: 'PSG',
  FBSCI047000: 'PDN',
  FBSCI048000: 'PNV',
  FBSCI049000: 'PSD',
  FBSCI050000: 'PDT',
  FBSCI051000: 'PHN',
  FBSCI052000: 'RBKC',
  FBSCI053000: 'PHJ',
  FBSCI054000: 'RBX',
  FBSCI055000: 'PH',
  FBSCI056000: 'PS',
  FBSCI057000: 'PHQ',
  FBSCI058000: 'PNRL',
  FBSCI059000: 'TTBM',
  FBSCI060000: 'PD',
  FBSCI061000: 'PHR',
  FBSCI063000: 'PD',
  FBSCI064000: 'GPFC',
  FBSCI065000: 'PHH',
  FBSCI066000: 'PGZ',
  FBSCI067000: 'PHDS',
  FBSCI068000: 'PDD',
  FBSCI070000: 'PSV',
  FBSCI070010: 'PSVC',
  FBSCI070020: 'PSVA',
  FBSCI070030: 'PSVM',
  FBSCI070040: 'PSVJ',
  FBSCI070050: 'PSVM3',
  FBSCI072000: 'PSC',
  FBSCI073000: 'PST',
  FBSCI074000: 'PHM',
  FBSCI075000: 'PDR',
  FBSCI076000: 'PDN',
  FBSCI077000: 'PHFC',
  FBSCI078000: 'PNFS',
  FBSCI079000: 'PHDT',
  FBSCI080000: 'PD',
  FBSCI081000: 'RBK',
  FBSCI082000: 'RBC',
  FBSCI083000: 'RBKF',
  FBSCI084000: 'PHDF',
  FBSCI085000: 'PHDF',
  FBSCI086000: 'PS',
  FBSCI087000: 'PSAB',
  FBSCI088000: 'RNCB',
  FBSCI089000: 'PSAN',
  FBSEL000000: 'VS',
  FBSEL001000: 'VFJM',
  FBSEL026000: 'VFJK',
  FBSEL036000: 'VFJ',
  FBSOC000000: 'JB',
  FBSOC002000: 'JHM',
  FBSOC003000: 'NK',
  FBSOC004000: 'JKV',
  FBSOC005000: 'JBGB',
  FBSOC006000: 'JHBD',
  FBSOC007000: 'JBFH',
  FBSOC010000: 'JBSF11',
  FBSOC015000: 'RGC',
  FBSOC025000: 'JKNS',
  FBSOC026000: 'JHB',
  FBSOC027000: 'JHBC',
  FBSOC031000: 'JBFA',
  FBSOC037000: 'JBFZ',
  FBSOC038000: 'JBSX',
  FBSOC040000: 'JBFF',
  FBSOC042000: 'GTP',
  FBSOC052000: 'JBCT',
  FBSOC053000: 'GTM',
  FBSOC054000: 'NHTS',
  FBSOC055000: 'JBCC4',
  FBSPO000000: 'SC',
  FBSPO001000: 'SMC',
  FBSPO002000: 'SVR',
  FBSPO003000: 'SFC',
  FBSPO004000: 'SFM',
  FBSPO005000: 'SPN',
  FBSPO006000: 'SXB',
  FBSPO007000: 'SFV',
  FBSPO008000: 'SRB',
  FBSPO009000: 'SZR',
  FBSPO010000: 'SPNK',
  FBSPO011000: 'SZD',
  FBSPO012000: 'SC',
  FBSPO014000: 'SVF',
  FBSPO015000: 'SFBD',
  FBSPO016000: 'SFH',
  FBSPO017000: 'SHG',
  FBSPO018000: 'SZC',
  FBSPO019000: 'SCX',
  FBSPO020000: 'STK',
  FBSPO021000: 'SKG',
  FBSPO022000: 'SVH',
  FBSPO023000: 'STG',
  FBSPO024000: 'ATX',
  FBSPO025000: 'SPNK',
  FBSPO026000: 'SFK',
  FBSPO027000: 'SR',
  FBSPO028000: 'SMF',
  FBSPO029000: 'SZG',
  FBSPO030000: 'SZ',
  FBSPO031000: 'SFT',
  FBSPO032000: 'SFT',
  FBSPO033000: 'SC',
  FBSPO034000: 'SMX',
  FBSPO035000: 'SZE',
  FBSPO036000: 'SPNG',
  FBSPO037000: 'SVT',
  FBSPO038000: 'SMX',
  FBSPO039000: 'STA',
  FBSPO040000: 'SCG',
  FBSPO041000: 'SCGP',
  FBSPO042000: 'SFTC',
  FBSPO043000: 'SPC',
  FBSPO044000: 'SFTD',
  FBSPO045000: 'SFTA',
  FBSPO046000: 'SHB',
  FBSPO047000: 'SCG',
  FBSPO048000: 'SHBM',
  FBSPO049000: 'SFP',
  FBSPO050000: 'SZC',
  FBSPO051000: 'SP',
  FBSPO052000: 'ST',
  FBSPO053000: 'SRC',
  FBSPO054000: 'SFD',
  FBSPO055000: 'SK',
  FBSPO056000: 'SFBT',
  FBSPO057000: 'SK',
  FBSPO058000: 'SCBB',
  FBSPO059000: 'SPCA',
  FBSPO060000: 'SFX',
  FBSPO061000: 'SCG',
  FBSPO061010: 'SCG',
  FBSPO061020: 'SCG',
  FBSPO062000: 'SKR',
  FBSPO063000: 'SC',
  FBSPO064000: 'SXQ',
  FBSPO065000: 'ATXZ',
  FBSPO066000: 'JHBS',
  FBSPO067000: 'SFC',
  FBSPO068000: 'SCBM',
  FBSPO069000: 'SPG',
  FBSPO070000: 'SX',
  FBSPO071000: 'SRF',
  FBSPO072000: 'STC',
  FBSTU001000: 'YPZ',
  FBSTU004000: 'DSRC',
  FBSTU008000: 'YPZ',
  FBSTU011000: 'KFCX',
  FBSTU012000: 'YPZ',
  FBSTU013000: 'JNDH',
  FBSTU016000: 'JNDH',
  FBSTU017000: 'LX',
  FBSTU018000: 'JNDH',
  FBSTU019000: 'JNDH',
  FBSTU024000: 'YPZ',
  FBSTU027000: 'YPZ',
  FBSTU028000: 'YPZ',
  FBSTU032000: 'JNDH',
  FBSTU033000: 'YPZ',
  FBTEC000000: 'TB',
  FBTEC001000: 'TTA',
  FBTEC001000N: 'TB',
  FBTEC002000: 'TRP',
  FBTEC003000: 'TV',
  FBTEC003010: 'TVQ',
  FBTEC003020: 'TVH',
  FBTEC003030: 'TVK',
  FBTEC003040: 'TVR',
  FBTEC003050: 'TVDR',
  FBTEC003060: 'TVBP',
  FBTEC003070: 'TVF',
  FBTEC003080: 'TVK',
  FBTEC003090: 'TVG',
  FBTEC004000: 'TJFM',
  FBTEC005000: 'TNK',
  FBTEC005010: 'TNT',
  FBTEC005020: 'TNKP',
  FBTEC005030: 'THRX',
  FBTEC005040: 'TNKP',
  FBTEC005050: 'TNKH',
  FBTEC005060: 'TNT',
  FBTEC005070: 'TNT',
  FBTEC005080: 'TNT',
  FBTEC006000: 'TBG',
  FBTEC007000: 'THR',
  FBTEC008000: 'TJF',
  FBTEC008010: 'TJFC',
  FBTEC008020: 'TJFC',
  FBTEC008030: 'TJFC',
  FBTEC008050: 'TJFC',
  FBTEC008060: 'TJF',
  FBTEC008070: 'TJF',
  FBTEC008080: 'TGMM',
  FBTEC008090: 'TJFD',
  FBTEC008100: 'TJF',
  FBTEC008110: 'TJFD',
  FBTEC009000: 'TBC',
  FBTEC009010: 'TDC',
  FBTEC009060: 'TD',
  FBTEC009070: 'TGB',
  FBTEC009080: 'THK',
  FBTEC009090: 'TRC',
  FBTEC009100: 'TNCJ',
  FBTEC009110: 'TNF',
  FBTEC009120: 'TNCE',
  FBTEC009130: 'TNFL',
  FBTEC009140: 'TNH',
  FBTEC009150: 'TNCC',
  FBTEC009160: 'TR',
  FBTEC010000: 'TQ',
  FBTEC011000: 'TTBF',
  FBTEC012000: 'TDCT',
  FBTEC013000: 'TGMD',
  FBTEC014000: 'TGMF',
  FBTEC015000: 'TTBM',
  FBTEC016000: 'TBD',
  FBTEC016010: 'TBD',
  FBTEC016020: 'AKP',
  FBTEC017000: 'KNX',
  FBTEC018000: 'TD',
  FBTEC019000: 'TTBL',
  FBTEC020000: 'TD',
  FBTEC021000: 'TGM',
  FBTEC023000: 'TDPM',
  FBTEC024000: 'TJFN',
  FBTEC025000: 'TTM',
  FBTEC026000: 'TTU',
  FBTEC027000: 'TBN',
  FBTEC029000: 'TBC',
  FBTEC030000: 'TTB',
  FBTEC031000: 'TH',
  FBTEC031010: 'THV',
  FBTEC031020: 'THY',
  FBTEC031030: 'THF',
  FBTEC032000: 'TGPQ',
  FBTEC033000: 'TJKD',
  FBTEC034000: 'TJKR',
  FBTEC036000: 'RGW',
  FBTEC037000: 'TJFM1',
  FBTEC039000: 'TJFD',
  FBTEC041000: 'TJK',
  FBTEC043000: 'TJKV',
  FBTEC045000: 'TNKF',
  FBTEC046000: 'TGB',
  FBTEC047000: 'THFP',
  FBTEC048000: 'RGV',
  FBTEC049000: 'TVT',
  FBTEC050000: 'TTBL',
  FBTEC054000: 'TNCB',
  FBTEC055000: 'TGMP',
  FBTEC057000: 'TBY',
  FBTEC058000: 'TVP',
  FBTEC059000: 'MQW',
  FBTEC060000: 'TTS',
  FBTEC061000: 'TJKT1',
  FBTEC063000: 'TNC',
  FBTEC064000: 'TJFD',
  FBTRA000000: 'WG',
  FBTRA001000: 'WGC',
  FBTRA001010: 'WGC',
  FBTRA001020: 'WGC',
  FBTRA001030: 'WGCV',
  FBTRA001050: 'WGC',
  FBTRA001060: 'WGC',
  FBTRA001140: 'WGCV',
  FBTRA001150: 'WGC',
  FBTRA002000: 'WGM',
  FBTRA002010: 'WGM',
  FBTRA002030: 'TRP',
  FBTRA002040: 'KNG',
  FBTRA002050: 'TRPS',
  FBTRA003000: 'WGCK',
  FBTRA003010: 'WGCK',
  FBTRA003020: 'WGCK',
  FBTRA003030: 'WGCK',
  FBTRA004000: 'WGF',
  FBTRA004010: 'WGF',
  FBTRA004020: 'WGF',
  FBTRA006000: 'WGG',
  FBTRA006010: 'WGG',
  FBTRA006020: 'WGG',
  FBTRA006030: 'WGGV',
  FBTRA008000: 'TRLN',
  FBTRA009000: 'RPT',
  FBTRU000000: 'DNXC',
  FBTRU001000: 'DNXC',
  FBTRV000000: 'WT',
  FBTRV001000N: 'WT',
  FBTRV002000: 'WT',
  FBTRV002010: 'WT',
  FBTRV002020: 'WT',
  FBTRV002030: 'WT',
  FBTRV002040: 'WT',
  FBTRV002050: 'WT',
  FBTRV002060: 'WT',
  FBTRV002070: 'WT',
  FBTRV002080: 'WT',
  FBTRV003000: 'WT',
  FBTRV003010: 'WT',
  FBTRV003020: 'WT',
  FBTRV003030: 'WT',
  FBTRV003040: 'WT',
  FBTRV003050: 'WT',
  FBTRV003060: 'WT',
  FBTRV003070: 'WT',
  FBTRV004000: 'WT',
  FBTRV006000: 'WT',
  FBTRV006010: 'WT',
  FBTRV006020: 'WT',
  FBTRV006030: 'WT',
  FBTRV006040: 'WT',
  FBTRV006050: 'WT',
  FBTRV006060: 'WT',
  FBTRV007000: 'WT',
  FBTRV008000: 'WT',
  FBTRV009000: 'WT',
  FBTRV009010: 'WT',
  FBTRV009020: 'WT',
  FBTRV009030: 'WT',
  FBTRV009040: 'WT',
  FBTRV009050: 'WT',
  FBTRV009060: 'WT',
  FBTRV009070: 'WT',
  FBTRV009080: 'WT',
  FBTRV009090: 'WT',
  FBTRV009100: 'WT',
  FBTRV009110: 'WT',
  FBTRV009120: 'WT',
  FBTRV009130: 'WT',
  FBTRV009140: 'WT',
  FBTRV010000: 'WT',
  FBTRV014000: 'WT',
  FBTRV015000: 'WT',
  FBTRV015010: 'WT',
  FBTRV015020: 'WT',
  FBTRV015030: 'WT',
  FBTRV016000: 'WTHM',
  FBTRV018000: 'WTHH1',
  FBTRV022000: 'WTHH',
  FBTRV023000: 'WT',
  FBTRV024000: 'WT',
  FBTRV024010: 'WT',
  FBTRV024020: 'WT',
  FBTRV024030: 'WT',
  FBTRV024040: 'WT',
  FBTRV024050: 'WT',
  FBTRV025000: 'WT',
  FBTRV025010: 'WT',
  FBTRV025020: 'WT',
  FBTRV025030: 'WT',
  FBTRV025040: 'WT',
  FBTRV025050: 'WT',
  FBTRV025060: 'WT',
  FBTRV025070: 'WT',
  FBTRV025080: 'WT',
  FBTRV025090: 'WT',
  FBTRV025100: 'WT',
  FBTRV025110: 'WT',
  FBTRV025120: 'WT',
  FBTRV025130: 'WT',
  FBTRV026020: 'WTHC',
  FBTRV026030: 'WTH',
  FBTRV026070: 'WTH',
  FBTRV026080: 'WTHE',
  FBTRV028000: 'WTHX',
  FBTRV029000: 'WTHT',
  FBTRV032000: 'WTH',
  FBTRV034000: 'WTHE',
};

export default mapping;
